import { jsx, jsxs } from 'react/jsx-runtime';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$a =
  // eslint-disable-next-line es-x/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$9 = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$8 = fails$9;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$8(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var fails$7 = fails$9;

var functionBindNative = !fails$7(function () {
  // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$1 = functionBindNative;

var call$5 = Function.prototype.call;

var functionCall = NATIVE_BIND$1 ? call$5.bind(call$5) : function () {
  return call$5.apply(call$5, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$2 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND = functionBindNative;

var FunctionPrototype$1 = Function.prototype;
var bind = FunctionPrototype$1.bind;
var call$4 = FunctionPrototype$1.call;
var uncurryThis$a = NATIVE_BIND && bind.bind(call$4, call$4);

var functionUncurryThis = NATIVE_BIND ? function (fn) {
  return fn && uncurryThis$a(fn);
} : function (fn) {
  return fn && function () {
    return call$4.apply(fn, arguments);
  };
};

var uncurryThis$9 = functionUncurryThis;

var toString$1 = uncurryThis$9({}.toString);
var stringSlice = uncurryThis$9(''.slice);

var classofRaw = function (it) {
  return stringSlice(toString$1(it), 8, -1);
};

var uncurryThis$8 = functionUncurryThis;
var fails$6 = fails$9;
var classof = classofRaw;

var $Object$2 = Object;
var split = uncurryThis$8(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$6(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$2('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : $Object$2(it);
} : $Object$2;

var $TypeError$5 = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$2 = function (it) {
  if (it == undefined) throw $TypeError$5("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$1 = requireObjectCoercible$2;

var toIndexedObject$3 = function (it) {
  return IndexedObject$1(requireObjectCoercible$1(it));
};

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$a = function (argument) {
  return typeof argument == 'function';
};

var isCallable$9 = isCallable$a;

var isObject$5 = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$9(it);
};

var global$9 = global$a;
var isCallable$8 = isCallable$a;

var aFunction = function (argument) {
  return isCallable$8(argument) ? argument : undefined;
};

var getBuiltIn$3 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$9[namespace]) : global$9[namespace] && global$9[namespace][method];
};

var uncurryThis$7 = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$7({}.isPrototypeOf);

var getBuiltIn$2 = getBuiltIn$3;

var engineUserAgent = getBuiltIn$2('navigator', 'userAgent') || '';

var global$8 = global$a;
var userAgent = engineUserAgent;

var process = global$8.process;
var Deno = global$8.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es-x/no-symbol -- required for testing */

var V8_VERSION = engineV8Version;
var fails$5 = fails$9;

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$5(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es-x/no-symbol -- required for testing */

var NATIVE_SYMBOL$1 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$1
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var getBuiltIn$1 = getBuiltIn$3;
var isCallable$7 = isCallable$a;
var isPrototypeOf = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$1 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$1('Symbol');
  return isCallable$7($Symbol) && isPrototypeOf($Symbol.prototype, $Object$1(it));
};

var $String$1 = String;

var tryToString$1 = function (argument) {
  try {
    return $String$1(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$6 = isCallable$a;
var tryToString = tryToString$1;

var $TypeError$4 = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$1 = function (argument) {
  if (isCallable$6(argument)) return argument;
  throw $TypeError$4(tryToString(argument) + ' is not a function');
};

var aCallable = aCallable$1;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$1 = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};

var call$3 = functionCall;
var isCallable$5 = isCallable$a;
var isObject$4 = isObject$5;

var $TypeError$3 = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$5(fn = input.toString) && !isObject$4(val = call$3(fn, input))) return val;
  if (isCallable$5(fn = input.valueOf) && !isObject$4(val = call$3(fn, input))) return val;
  if (pref !== 'string' && isCallable$5(fn = input.toString) && !isObject$4(val = call$3(fn, input))) return val;
  throw $TypeError$3("Can't convert object to primitive value");
};

var shared$3 = {exports: {}};

var global$7 = global$a;

// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty$2 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$2(global$7, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$7[key] = value;
  } return value;
};

var global$6 = global$a;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = global$6[SHARED] || defineGlobalProperty$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$3.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.23.5',
  mode: 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.23.5/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var requireObjectCoercible = requireObjectCoercible$2;

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$2 = function (argument) {
  return $Object(requireObjectCoercible(argument));
};

var uncurryThis$6 = functionUncurryThis;
var toObject$1 = toObject$2;

var hasOwnProperty = uncurryThis$6({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$1(it), key);
};

var uncurryThis$5 = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString = uncurryThis$5(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};

var global$5 = global$a;
var shared$2 = shared$3.exports;
var hasOwn$6 = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared$2('wks');
var Symbol$1 = global$5.Symbol;
var symbolFor = Symbol$1 && Symbol$1['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$1 = function (name) {
  if (!hasOwn$6(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn$6(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};

var call$2 = functionCall;
var isObject$3 = isObject$5;
var isSymbol$1 = isSymbol$2;
var getMethod = getMethod$1;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol = wellKnownSymbol$1;

var $TypeError$2 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$3(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$2(exoticToPrim, input, pref);
    if (!isObject$3(result) || isSymbol$1(result)) return result;
    throw $TypeError$2("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$4 = global$a;
var isObject$2 = isObject$5;

var document = global$4.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$2(document) && isObject$2(document.createElement);

var documentCreateElement = function (it) {
  return EXISTS$1 ? document.createElement(it) : {};
};

var DESCRIPTORS$7 = descriptors;
var fails$4 = fails$9;
var createElement = documentCreateElement;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$7 && !fails$4(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$6 = descriptors;
var call$1 = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$1 = createPropertyDescriptor$2;
var toIndexedObject$2 = toIndexedObject$3;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$5 = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$6 ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$2(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$5(O, P)) return createPropertyDescriptor$1(!call$1(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$5 = descriptors;
var fails$3 = fails$9;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$5 && fails$3(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var isObject$1 = isObject$5;

var $String = String;
var $TypeError$1 = TypeError;

// `Assert: Type(argument) is Object`
var anObject$2 = function (argument) {
  if (isObject$1(argument)) return argument;
  throw $TypeError$1($String(argument) + ' is not an object');
};

var DESCRIPTORS$4 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var anObject$1 = anObject$2;
var toPropertyKey = toPropertyKey$2;

var $TypeError = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$4 ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject$1(O);
  P = toPropertyKey(P);
  anObject$1(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$1(O);
  P = toPropertyKey(P);
  anObject$1(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$3 = descriptors;
var definePropertyModule$2 = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$2;

var createNonEnumerableProperty$2 = DESCRIPTORS$3 ? function (object, key, value) {
  return definePropertyModule$2.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$2 = {exports: {}};

var DESCRIPTORS$2 = descriptors;
var hasOwn$4 = hasOwnProperty_1;

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$2 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$4(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$2 || (DESCRIPTORS$2 && getDescriptor(FunctionPrototype, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$4 = functionUncurryThis;
var isCallable$4 = isCallable$a;
var store$1 = sharedStore;

var functionToString = uncurryThis$4(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$4(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$2 = store$1.inspectSource;

var global$3 = global$a;
var isCallable$3 = isCallable$a;
var inspectSource$1 = inspectSource$2;

var WeakMap$1 = global$3.WeakMap;

var nativeWeakMap = isCallable$3(WeakMap$1) && /native code/.test(inspectSource$1(WeakMap$1));

var shared$1 = shared$3.exports;
var uid = uid$2;

var keys = shared$1('keys');

var sharedKey$1 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$3 = {};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$2 = global$a;
var uncurryThis$3 = functionUncurryThis;
var isObject = isObject$5;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$2;
var hasOwn$3 = hasOwnProperty_1;
var shared = sharedStore;
var sharedKey = sharedKey$1;
var hiddenKeys$2 = hiddenKeys$3;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = global$2.TypeError;
var WeakMap = global$2.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$1('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = uncurryThis$3(store.get);
  var wmhas = uncurryThis$3(store.has);
  var wmset = uncurryThis$3(store.set);
  set = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys$2[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn$3(it, STATE)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$1(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$3(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$3(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var fails$2 = fails$9;
var isCallable$2 = isCallable$a;
var hasOwn$2 = hasOwnProperty_1;
var DESCRIPTORS$1 = descriptors;
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
var inspectSource = inspectSource$2;
var InternalStateModule = internalState;

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty$1 = Object.defineProperty;

var CONFIGURABLE_LENGTH = DESCRIPTORS$1 && !fails$2(function () {
  return defineProperty$1(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$1 = makeBuiltIn$2.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$2(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS$1) defineProperty$1(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$2(options, 'arity') && value.length !== options.arity) {
    defineProperty$1(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$2(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$1) defineProperty$1(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$2(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$1(function toString() {
  return isCallable$2(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');

var isCallable$1 = isCallable$a;
var definePropertyModule$1 = objectDefineProperty;
var makeBuiltIn = makeBuiltIn$2.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$1 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$1(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$1.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$2 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$1 = toIntegerOrInfinity$2;

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$1(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

var toIntegerOrInfinity = toIntegerOrInfinity$2;

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength = toLength$1;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$1 = function (obj) {
  return toLength(obj.length);
};

var toIndexedObject$1 = toIndexedObject$3;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike = lengthOfArrayLike$1;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$1($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var uncurryThis$2 = functionUncurryThis;
var hasOwn$1 = hasOwnProperty_1;
var toIndexedObject = toIndexedObject$3;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$1 = hiddenKeys$3;

var push = uncurryThis$2([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$1(hiddenKeys$1, key) && hasOwn$1(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$1(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$2 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$2;

var hiddenKeys = enumBugKeys$1.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn = getBuiltIn$3;
var uncurryThis$1 = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject = anObject$2;

var concat$1 = uncurryThis$1([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$1 = fails$9;
var isCallable = isCallable$a;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails$1(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var global$1 = global$a;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty = createNonEnumerableProperty$2;
var defineBuiltIn = defineBuiltIn$1;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$1;
  } else if (STATIC) {
    target = global$1[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global$1[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys = enumBugKeys$2;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
var objectKeys$1 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};

var DESCRIPTORS = descriptors;
var uncurryThis = functionUncurryThis;
var call = functionCall;
var fails = fails$9;
var objectKeys = objectKeys$1;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject = toObject$2;
var IndexedObject = indexedObject;

// eslint-disable-next-line es-x/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es-x/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $ = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es-x/no-object-assign -- required for testing
$({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

function getSize(size) {
  switch (size) {
    case 'Small':
      return '13px';

    case 'Medium':
      return '20px';

    case 'Large':
      return '24px';

    case 'XLarge':
      return '32px';

    case 'XXLarge':
      return '60px';

    default:
      return '20px';
  }
}

const Icon = ({
  size: _size = 'Medium',
  color,
  label,
  inactive: _inactive = false,
  id,
  children
}) => jsx("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  role: label ? undefined : 'presentation',
  "aria-label": label,
  viewBox: "0 0 20 20",
  fill: color,
  focusable: "false",
  id: id,
  height: getSize(_size),
  width: getSize(_size),
  opacity: _inactive ? 0.35 : 1
}, {
  children: children
}));

const Acrobat = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "acrobat"
    }, {
      children: [jsx("path", {
        d: "M1,1V23H23V1ZM21,21H3V3H21Z"
      }), jsx("path", {
        d: "M6.11,18.64h.15c1.1,0,3.05-1.39,4.65-3.49A3.55,3.55,0,0,1,12,15a8.43,8.43,0,0,1,1,0,8.5,8.5,0,0,0,4.12,2.22A1.7,1.7,0,0,0,18.55,17a1.13,1.13,0,0,0,.27-1.26c-.37-1-2.27-2.17-4.82-2.58a3.67,3.67,0,0,1-.45-.64A11.46,11.46,0,0,1,13,11.17c.8-2.62.52-4.79.07-5.54A1.18,1.18,0,0,0,12,5a1.27,1.27,0,0,0-1.1.69c-.51.85-.84,2.9-.05,5.48a11.2,11.2,0,0,1-.6,1.35c-.19.34-.39.65-.58,1a10.55,10.55,0,0,0-4,2.9,1.68,1.68,0,0,0-.48,1.43A1.12,1.12,0,0,0,6.11,18.64Z"
      })]
    }))
  }))
}));

const Actions = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M149.48,16.28a2.29,2.29,0,1,1,0-4.57h2.31V14a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M152.21,11.29V6.72a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M154.61,16.28a2.28,2.28,0,0,1-2.4-2.23V11.71h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M151.79,9a2.32,2.32,0,1,1-2.32-2.28A2.3,2.3,0,0,1,151.79,9",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "actions"
    }, {
      children: [jsx("polygon", {
        points: "9.65 17.5 10.99 17.5 17.41 11 11.41 11 14.35 6.5 13.01 6.5 6.59 13 12.59 13 9.65 17.5"
      }), jsx("path", {
        d: "M1,1V23H23V1ZM21,21H3V3H21Z"
      })]
    }))]
  }))
}));

const AddColumn = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M-258.54,176.28a2.31,2.31,0,0,1-2.33-2.28,2.3,2.3,0,0,1,2.33-2.29h2.3V174a2.3,2.3,0,0,1-2.3,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M-255.82,171.29v-4.57a4.48,4.48,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M-253.42,176.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M-256.24,169a2.29,2.29,0,0,1-2.31,2.29,2.3,2.3,0,0,1-2.32-2.29,2.3,2.3,0,0,1,2.32-2.28,2.29,2.29,0,0,1,2.31,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "Layer_6",
      "data-name": "Layer 6"
    }, {
      children: [jsx("path", {
        d: "M15,5V19H9V5h6m2-2H7V21H17V3Z"
      }), jsx("polygon", {
        points: "18.97 15 16.97 15 16.97 17 14.97 17 14.97 19 16.97 19 16.97 21 18.97 21 18.97 19 20.97 19 20.97 17 18.97 17 18.97 15",
        fill: "#fff"
      }), jsx("path", {
        d: "M18,12a6,6,0,1,0,6,6,6,6,0,0,0-6-6Zm-3,7V17h2V15h2v2h2v2H19v2H17V19Z"
      })]
    }))]
  }))
}));

const AddItem = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M-191.54,176.28a2.31,2.31,0,0,1-2.33-2.28,2.3,2.3,0,0,1,2.33-2.29h2.3V174a2.3,2.3,0,0,1-2.3,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M-188.82,171.29v-4.57a4.48,4.48,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M-186.42,176.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M-189.24,169a2.29,2.29,0,0,1-2.31,2.29,2.3,2.3,0,0,1-2.32-2.29,2.3,2.3,0,0,1,2.32-2.28,2.29,2.29,0,0,1,2.31,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "Layer_6",
      "data-name": "Layer 6"
    }, {
      children: [jsx("rect", {
        x: "5.97",
        y: "6",
        width: "2",
        height: "2"
      }), jsx("rect", {
        x: "9.97",
        y: "6",
        width: "8",
        height: "2"
      }), jsx("path", {
        d: "M18,12a6,6,0,1,0,6,6A6,6,0,0,0,18,12Zm3,7H19v2H17V19H15V17h2V15h2v2h2Z"
      }), jsx("path", {
        d: "M11.66,21H3V3H21v8.69a6.74,6.74,0,0,1,2,1.42V1H1V23H13.08A6.93,6.93,0,0,1,11.66,21Z"
      }), jsx("path", {
        d: "M23,20.41V14.69a6,6,0,0,0-2-1.88V21H12.78a6.1,6.1,0,0,0,1.88,2h5.71Z"
      })]
    }))]
  }))
}));

const AddSectionAbove = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "Layer_6",
      "data-name": "Layer 6"
    }, {
      children: [jsx("rect", {
        x: "0.97",
        y: "1",
        width: "10",
        height: "2"
      }), jsx("path", {
        d: "M18,12a6,6,0,1,0,6,6,6,6,0,0,0-6-6Zm-3,7V17h2V15h2v2h2v2H19v2H17V19Z"
      }), jsx("path", {
        d: "M12.29,22.08v0A7,7,0,0,1,11.66,21H3V13H13.08A7,7,0,0,1,17,11.08V11H3V7H7.41l1.2,2H21v2H19v.08a7,7,0,0,1,4,2h0V7H9.74L8.54,5H1V23H13.08A7,7,0,0,1,12.29,22.08Z"
      })]
    }))
  }))
}));

const AddSectionBelow = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "Layer_6",
      "data-name": "Layer 6"
    }, {
      children: [jsx("rect", {
        x: "0.97",
        y: "21",
        width: "10",
        height: "2"
      }), jsx("path", {
        d: "M18,12a6,6,0,1,0,6,6,6,6,0,0,0-6-6Zm-3,7V17h2V15h2v2h2v2H19v2H17V19Z"
      }), jsx("path", {
        d: "M11,18a8.26,8.26,0,0,1,.08-1H3V9H21v2.69a6.74,6.74,0,0,1,2,1.42V3H9.74L8.54,1H1V19H11.05A8.26,8.26,0,0,1,11,18ZM3,3H7.41l1.2,2H21V7H3Z"
      })]
    }))
  }))
}));

const AddSection = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "Layer_6",
      "data-name": "Layer 6"
    }, {
      children: [jsx("path", {
        d: "M18,12a6,6,0,1,0,6,6,6,6,0,0,0-6-6Zm-3,7V17h2V15h2v2h2v2H19v2H17V19Z"
      }), jsx("path", {
        d: "M11.05,19H3V11H21v.69a6.74,6.74,0,0,1,2,1.42V5H9.74L8.54,3H1V21H11.66A6.74,6.74,0,0,1,11.05,19ZM3,5H7.41l1.2,2H21V9H3Z"
      })]
    }))
  }))
}));

const AddTab = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M-224.54,176.28a2.31,2.31,0,0,1-2.33-2.28,2.3,2.3,0,0,1,2.33-2.29h2.3V174a2.3,2.3,0,0,1-2.3,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M-221.82,171.29v-4.57a4.48,4.48,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M-219.42,176.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M-222.24,169a2.29,2.29,0,0,1-2.31,2.29,2.3,2.3,0,0,1-2.32-2.29,2.3,2.3,0,0,1,2.32-2.28,2.29,2.29,0,0,1,2.31,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "Layer_6",
      "data-name": "Layer 6"
    }, {
      children: [jsx("path", {
        d: "M18,12a6,6,0,1,0,6,6,6,6,0,0,0-6-6Zm-3,7V17h2V15h2v2h2v2H19v2H17V19Z"
      }), jsx("path", {
        d: "M11.05,19H3V5H9.41l1.2,2H21v4.69a6.74,6.74,0,0,1,2,1.42V5H11.74l-1.2-2H1V21H11.66A6.74,6.74,0,0,1,11.05,19Z"
      })]
    }))]
  }))
}));

const Administrator = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M269.48-183.72a2.31,2.31,0,0,1-2.32-2.28,2.3,2.3,0,0,1,2.32-2.29h2.31V-186a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M272.21-188.71v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M274.61-183.72a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M271.79-191a2.3,2.3,0,0,1-2.32,2.29,2.29,2.29,0,0,1-2.31-2.29,2.29,2.29,0,0,1,2.31-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsx("g", Object.assign({
      id: "administrator"
    }, {
      children: jsx("path", {
        d: "M23.83,14.28l.21-2-2-.22v0a10,10,0,0,0-.23-2.13l1.95-.63-.62-1.9-2,.63a10.6,10.6,0,0,0-1.09-1.88l1.53-1.38L20.25,3.25,18.72,4.63A10.55,10.55,0,0,0,17,3.35l.83-1.88L16,.66l-.84,1.87A10,10,0,0,0,13,2.08V0H11V2.08a10,10,0,0,0-2.13.45L8,.66l-1.82.81L7,3.35A10.55,10.55,0,0,0,5.28,4.63L3.75,3.25,2.41,4.74,3.94,6.12A10.6,10.6,0,0,0,2.85,8L.9,7.37.28,9.27l2,.63A10,10,0,0,0,2,12v0l-2,.22.21,2,2-.22a9.48,9.48,0,0,0,.68,2.07l-1.78,1,1,1.73,1.78-1a10.23,10.23,0,0,0,1.46,1.62L4.14,21.15l1.62,1.17L7,20.66a9.82,9.82,0,0,0,2,.89l-.42,2,2,.41.43-2c.36,0,.72.06,1.09.06s.73,0,1.09-.06l.43,2,2-.41-.42-2a9.82,9.82,0,0,0,2-.89l1.21,1.66,1.62-1.17-1.21-1.67a10.23,10.23,0,0,0,1.46-1.62l1.78,1,1-1.73-1.78-1a9.48,9.48,0,0,0,.68-2.07ZM12,20A8,8,0,0,1,8,19L8.78,16h6.44L16,19A8,8,0,0,1,12,20ZM9.67,11c0-1.65,1-3,2.33-3s2.33,1.35,2.33,3-1,3-2.33,3S9.67,12.65,9.67,11Zm8,6.62L16.78,14H15.44a5.46,5.46,0,0,0,.89-3c0-2.76-1.94-5-4.33-5S7.67,8.24,7.67,11a5.46,5.46,0,0,0,.89,3H7.22l-.91,3.62a8,8,0,1,1,11.38,0Z"
      })
    }))]
  }))
}));

const Archive = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M309.48,96.28a2.29,2.29,0,1,1,0-4.57h2.31V94a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M312.21,91.29V86.72a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M314.61,96.28a2.28,2.28,0,0,1-2.4-2.23V91.71h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M311.79,89a2.32,2.32,0,1,1-2.32-2.28A2.3,2.3,0,0,1,311.79,89",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "archive"
    }, {
      children: [jsx("path", {
        d: "M3,1V23H21V1ZM19,3v8H5V3ZM5,21V13H19v8Z"
      }), jsx("rect", {
        x: "10",
        y: "5",
        width: "4",
        height: "2"
      }), jsx("rect", {
        x: "10",
        y: "15",
        width: "4",
        height: "2"
      })]
    }))]
  }))
}));

const Archived = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M189.48,216.28a2.29,2.29,0,1,1,0-4.57h2.31V214a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M192.21,211.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M194.61,216.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M191.79,209a2.32,2.32,0,1,1-2.32-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "archived"
    }, {
      children: [jsx("path", {
        d: "M1,1V23H23V1ZM21,21H13V16.83l2,2V16l-2-2H11L9,16v2.83l2-2V21H3V3h8V7.17l-2-2V8l2,2h2l2-2V5.17l-2,2V3h8Z"
      }), jsx("rect", {
        x: "5",
        y: "11",
        width: "14",
        height: "2"
      })]
    }))]
  }))
}));

const ArrowCollapseAll = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M288.48-103.72a2.31,2.31,0,0,1-2.32-2.28,2.3,2.3,0,0,1,2.32-2.29h2.31V-106a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M291.21-108.71v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M293.61-103.72a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M290.79-111a2.3,2.3,0,0,1-2.32,2.29,2.29,2.29,0,0,1-2.31-2.29,2.29,2.29,0,0,1,2.31-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "arrow-collapse-all"
    }, {
      children: [jsx("polygon", {
        points: "3 13.83 12 4.83 21 13.83 21 10 12 1 3 10 3 13.83"
      }), jsx("polygon", {
        points: "3 22.83 12 13.83 21 22.83 21 19 12 10 3 19 3 22.83"
      })]
    }))]
  }))
}));

const ArrowDown = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsx("g", Object.assign({
      id: "arrow-down"
    }, {
      children: jsx("polygon", {
        points: "11 4 11 16.17 5 10.17 5 13 12 20 19 13 19 10.17 13 16.17 13 4 11 4"
      })
    }))
  }))
}));

const ArrowExpandAll = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M328.48-103.72a2.31,2.31,0,0,1-2.32-2.28,2.3,2.3,0,0,1,2.32-2.29h2.31V-106a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M331.21-108.71v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M333.61-103.72a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M330.79-111a2.3,2.3,0,0,1-2.32,2.29,2.29,2.29,0,0,1-2.31-2.29,2.29,2.29,0,0,1,2.31-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "arrow-expand-all"
    }, {
      children: [jsx("polygon", {
        points: "3 10 3 13.83 12 22.83 21 13.83 21 10 12 19 3 10"
      }), jsx("polygon", {
        points: "12 10 3 1 3 4.83 12 13.83 21 4.83 21 1 12 10"
      })]
    }))]
  }))
}));

const ArrowIndent = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsx("g", Object.assign({
      id: "arrow-indent"
    }, {
      children: jsx("path", {
        d: "M11.34,10l3,3H10.67A2.5,2.5,0,0,1,8.9,8.73L9.61,8,8.2,6.61l-.71.71A4.5,4.5,0,0,0,10.67,15h3.67l-3,3h2.83l4-4-4-4Z"
      })
    }))
  }))
}));

const ArrowLeft = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsx("g", Object.assign({
      id: "arrow-right"
    }, {
      children: jsx("polygon", {
        points: "20 11 7.83 11 13.83 5 11 5 4 12 11 19 13.83 19 7.83 13 20 13 20 11"
      })
    }))
  }))
}));

const ArrowRight = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsx("g", Object.assign({
      id: "arrow-left"
    }, {
      children: jsx("polygon", {
        points: "13 5 10.17 5 16.17 11 4 11 4 13 16.17 13 10.17 19 13 19 20 12 13 5"
      })
    }))
  }))
}));

const ArrowSortDown = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M48.48-103.72A2.31,2.31,0,0,1,46.16-106a2.3,2.3,0,0,1,2.32-2.29h2.31V-106a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M51.21-108.71v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M53.61-103.72a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M50.79-111a2.3,2.3,0,0,1-2.32,2.29A2.29,2.29,0,0,1,46.16-111a2.29,2.29,0,0,1,2.31-2.28A2.3,2.3,0,0,1,50.79-111",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "arrow-sort-down"
    }, {
      children: [jsx("polygon", {
        points: "11.96 19 15.24 13 8.69 13 11.96 19"
      }), jsx("path", {
        d: "M12,7.09,13.55,10H10.38L12,7.09M12,5,8.69,11h6.55L12,5Z"
      })]
    }))]
  }))
}));

const ArrowSortUp = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M88.48-103.72A2.31,2.31,0,0,1,86.16-106a2.3,2.3,0,0,1,2.32-2.29h2.31V-106a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M91.21-108.71v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M93.61-103.72a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M90.79-111a2.3,2.3,0,0,1-2.32,2.29A2.29,2.29,0,0,1,86.16-111a2.29,2.29,0,0,1,2.31-2.28A2.3,2.3,0,0,1,90.79-111",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "arrow-sort-up"
    }, {
      children: [jsx("polygon", {
        points: "12 5 8.73 11 15.27 11 12 5"
      }), jsx("path", {
        d: "M13.59,14,12,16.91,10.41,14h3.18m1.68-1H8.73L12,19l3.27-6Z"
      })]
    }))]
  }))
}));

const ArrowUp = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsx("g", Object.assign({
      id: "arrow-up"
    }, {
      children: jsx("polygon", {
        points: "13 20 13 7.83 19 13.83 19 11 12 4 5 11 5 13.83 11 7.83 11 20 13 20"
      })
    }))
  }))
}));

const Attachment = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M309.48,136.28a2.29,2.29,0,1,1,0-4.57h2.31V134a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M312.21,131.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M314.61,136.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M311.79,129a2.32,2.32,0,1,1-2.32-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsx("g", Object.assign({
      id: "attachment"
    }, {
      children: jsx("path", {
        d: "M17,6V17A5,5,0,0,1,7,17V5a3,3,0,0,1,6,0V17a1,1,0,0,1-2,0V6H9V17a3,3,0,0,0,6,0V5A5,5,0,0,0,5,5V17a7,7,0,0,0,14,0V6Z"
      })
    }))]
  }))
}));

const Audio = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M149.48,216.28a2.29,2.29,0,1,1,0-4.57h2.31V214a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M152.21,211.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M154.61,216.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M151.79,209a2.32,2.32,0,1,1-2.32-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "audio"
    }, {
      children: [jsx("path", {
        d: "M1,1V23H23V1ZM21,21H3V3H21Z"
      }), jsx("polygon", {
        points: "6 14 8 14 8 19 10 19 10 17 12 17 12 15 14 15 14 14 16 14 16 17 18 17 18 15 20 15 20 9 18 9 18 7 16 7 16 10 14 10 14 9 12 9 12 7 10 7 10 5 8 5 8 10 6 10 6 9 4 9 4 15 6 15 6 14"
      })]
    }))]
  }))
}));

const AwaitingAction = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M-1.51,296.28A2.31,2.31,0,0,1-3.83,294a2.3,2.3,0,0,1,2.32-2.29H.8V294a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M1.22,291.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M3.62,296.28a2.28,2.28,0,0,1-2.4-2.23v-2.34H5.85v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M.8,289a2.3,2.3,0,0,1-2.32,2.29A2.29,2.29,0,0,1-3.83,289a2.29,2.29,0,0,1,2.31-2.28A2.3,2.3,0,0,1,.8,289",
          clipRule: "evenodd"
        })
      }))]
    }), jsx("g", Object.assign({
      id: "awaiting-action"
    }, {
      children: jsx("polygon", {
        points: "20 10.86 14.76 10.86 18.46 7.15 16.85 5.54 13.14 9.24 13.14 4 10.86 4 10.86 9.24 7.15 5.54 5.54 7.15 9.24 10.86 4 10.86 4 13.14 9.24 13.14 5.54 16.85 7.15 18.46 10.86 14.76 10.86 20 13.14 20 13.14 14.76 16.85 18.46 18.46 16.85 14.76 13.14 20 13.14 20 10.86"
      })
    }))]
  }))
}));

const Broken = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsx("g", Object.assign({
      id: "broken"
    }, {
      children: jsx("path", {
        d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,2a10,10,0,0,1,9.34,6.46H9.88L8.46,9.88l3.66,3.66h-10A9.9,9.9,0,0,1,2,12,10,10,0,0,1,12,2Zm0,20a10,10,0,0,1-9.34-6.46H14.12l1.42-1.42-3.66-3.66h10A9.9,9.9,0,0,1,22,12,10,10,0,0,1,12,22Z"
      })
    }))
  }))
}));

const ChevronCollapsed = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M229.48-103.72a2.31,2.31,0,0,1-2.32-2.28,2.3,2.3,0,0,1,2.32-2.29h2.31V-106a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M232.21-108.71v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M234.61-103.72a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M231.79-111a2.3,2.3,0,0,1-2.32,2.29,2.29,2.29,0,0,1-2.31-2.29,2.29,2.29,0,0,1,2.31-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsx("g", Object.assign({
      id: "chevron-collapsed"
    }, {
      children: jsx("polygon", {
        points: "7 5 14 12 7 19 10.83 19 17.83 12 10.83 5 7 5"
      })
    }))]
  }))
}));

const ChevronExpanded = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M269.48-103.72a2.31,2.31,0,0,1-2.32-2.28,2.3,2.3,0,0,1,2.32-2.29h2.31V-106a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M272.21-108.71v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M274.61-103.72a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M271.79-111a2.3,2.3,0,0,1-2.32,2.29,2.29,2.29,0,0,1-2.31-2.29,2.29,2.29,0,0,1,2.31-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsx("g", Object.assign({
      id: "chevron-expanded"
    }, {
      children: jsx("polygon", {
        points: "19 7 12 14 5 7 5 10.83 12 17.83 19 10.83 19 7"
      })
    }))]
  }))
}));

const CloseLarge = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M-35.54,296.28A2.31,2.31,0,0,1-37.87,294a2.3,2.3,0,0,1,2.33-2.29h2.3V294a2.3,2.3,0,0,1-2.3,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M-32.82,291.29v-4.57a4.48,4.48,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M-30.42,296.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M-33.24,289a2.29,2.29,0,0,1-2.31,2.29A2.3,2.3,0,0,1-37.87,289a2.3,2.3,0,0,1,2.32-2.28A2.29,2.29,0,0,1-33.24,289",
          clipRule: "evenodd"
        })
      }))]
    }), jsx("g", Object.assign({
      id: "close-large"
    }, {
      children: jsx("polygon", {
        points: "23.02 2.38 21.6 0.97 11.99 10.58 2.43 1.01 1.01 2.43 10.58 11.99 0.97 21.6 2.38 23.02 11.99 13.4 21.59 23 23 21.59 13.4 11.99 23.02 2.38"
      })
    }))]
  }))
}));

const CloseSmall = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M32.49,296.28a2.29,2.29,0,1,1,0-4.57H34.8V294a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M35.22,291.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M37.62,296.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M34.8,289a2.32,2.32,0,1,1-2.32-2.28A2.3,2.3,0,0,1,34.8,289",
          clipRule: "evenodd"
        })
      }))]
    }), jsx("g", Object.assign({
      id: "close-small"
    }, {
      children: jsx("polygon", {
        points: "18.39 16.95 13.43 11.99 18.37 7.05 16.94 5.62 12 10.56 7.08 5.64 5.65 7.07 10.57 11.99 5.63 16.93 7.06 18.36 12 13.42 16.96 18.38 18.39 16.95"
      })
    }))]
  }))
}));

const Cloud = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsx("g", Object.assign({
      id: "cloud"
    }, {
      children: jsx("path", {
        d: "M24,14.5a5.5,5.5,0,0,0-4.56-5.41A8,8,0,0,0,4.06,11a4.49,4.49,0,0,0,.44,9H19a5.09,5.09,0,0,0,4.81-4.09h0A5.45,5.45,0,0,0,24,14.5ZM19,18H4.5a2.5,2.5,0,1,1,1.75-4.28A6,6,0,0,1,12,6a6,6,0,0,1,5.92,5.06A3.68,3.68,0,0,1,18.5,11,3.5,3.5,0,0,1,22,14.5,3.59,3.59,0,0,1,21.64,16h0A3.24,3.24,0,0,1,19,18Z"
      })
    }))
  }))
}));

const Colour = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M-66.59,296.28A2.31,2.31,0,0,1-68.92,294a2.3,2.3,0,0,1,2.33-2.29h2.31V294a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M-63.86,291.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M-61.47,296.28a2.28,2.28,0,0,1-2.39-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M-64.28,289a2.3,2.3,0,0,1-2.32,2.29A2.3,2.3,0,0,1-68.92,289a2.3,2.3,0,0,1,2.32-2.28A2.3,2.3,0,0,1-64.28,289",
          clipRule: "evenodd"
        })
      }))]
    }), jsx("g", Object.assign({
      id: "colour"
    }, {
      children: jsx("path", {
        d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0ZM22,12a10.09,10.09,0,0,1-.55,3.26L14.38,12l7-3.28A9.84,9.84,0,0,1,22,12ZM20.57,6.88,13,10.41V2.05A10,10,0,0,1,20.57,6.88ZM11,2.05v8.34L3.43,6.87A10,10,0,0,1,11,2.05ZM2,12a10,10,0,0,1,.57-3.3l7,3.28-7.06,3.3A9.91,9.91,0,0,1,2,12Zm1.41,5.09L11,13.55V22A10,10,0,0,1,3.41,17.09ZM13,22v-8.4l7.6,3.54A10,10,0,0,1,13,22Z"
      })
    }))]
  }))
}));

const Contact = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M309.48,176.28a2.29,2.29,0,1,1,0-4.57h2.31V174a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M312.21,171.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M314.61,176.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M311.79,169a2.32,2.32,0,1,1-2.32-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "contact"
    }, {
      children: [jsx("path", {
        d: "M1,3V21H23V3ZM21,19H3V5H21Z"
      }), jsx("rect", {
        x: "6",
        y: "8",
        width: "4",
        height: "6"
      }), jsx("rect", {
        x: "12",
        y: "8",
        width: "6",
        height: "2"
      }), jsx("rect", {
        x: "12",
        y: "12",
        width: "6",
        height: "2"
      })]
    }))]
  }))
}));

const CopyDeny = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "copy-deny"
    }, {
      children: [jsx("path", {
        d: "M11.68,21H3V7H6V19h5.08a6.29,6.29,0,0,1,0-2H8V3H21v8.68a7,7,0,0,1,2,1.43V1H6V5H1V23H13.11A7,7,0,0,1,11.68,21Z",
        fill: "#7b7b7e"
      }), jsx("path", {
        d: "M18,12a6,6,0,1,0,6,6A6,6,0,0,0,18,12Zm3,7H15V17h6Z",
        fill: "#db353d"
      })]
    }))
  }))
}));

const CopyTick = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "copy-tick"
    }, {
      children: [jsx("path", {
        d: "M11.68,21H3V7H6V19h5.08a6.29,6.29,0,0,1,0-2H8V3H21v8.68a7,7,0,0,1,2,1.43V1H6V5H1V23H13.11A7,7,0,0,1,11.68,21Z",
        fill: "#7b7b7e"
      }), jsx("path", {
        d: "M18,12a6,6,0,1,0,6,6A6,6,0,0,0,18,12Zm.7,9H16.44L14,18h2.58l.88,1.09L19.64,15h2.27Z",
        fill: "#32a31a"
      })]
    }))
  }))
}));

const Copy = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M269.48,136.28a2.29,2.29,0,1,1,0-4.57h2.31V134a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M272.21,131.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M274.61,136.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M271.79,129a2.32,2.32,0,1,1-2.32-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsx("g", Object.assign({
      id: "copy"
    }, {
      children: jsx("path", {
        d: "M23,1H6V5H1V23H18V19h5ZM16,21H3V7H6V19H16Zm5-4H8V3H21Z"
      })
    }))]
  }))
}));

const CrossStatus = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "ICONS"
    }, {
      children: [jsx("path", {
        d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z"
      }), jsx("polygon", {
        points: "15.29 7.29 12 10.59 8.71 7.29 7.29 8.71 10.59 12 7.29 15.29 8.71 16.71 12 13.41 15.29 16.71 16.71 15.29 13.41 12 16.71 8.71 15.29 7.29"
      })]
    }))
  }))
}));

const Cross = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M229.48,96.28a2.29,2.29,0,1,1,0-4.57h2.31V94a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M232.21,91.29V86.72a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M234.61,96.28a2.28,2.28,0,0,1-2.4-2.23V91.71h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M231.79,89a2.32,2.32,0,1,1-2.32-2.28A2.3,2.3,0,0,1,231.79,89",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "cross-2",
      "data-name": "cross"
    }, {
      children: [jsx("path", {
        d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z"
      }), jsx("polygon", {
        points: "16.24 6.34 12 10.59 7.76 6.34 6.34 7.76 10.59 12 6.34 16.24 7.76 17.66 12 13.41 16.24 17.66 17.66 16.24 13.41 12 17.66 7.76 16.24 6.34"
      })]
    }))]
  }))
}));

const Date = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M229.48,56.28a2.29,2.29,0,1,1,0-4.57h2.31V54a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M232.21,51.29V46.72a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M234.61,56.28a2.28,2.28,0,0,1-2.4-2.23V51.71h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M231.79,49a2.32,2.32,0,1,1-2.32-2.28A2.3,2.3,0,0,1,231.79,49",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "date"
    }, {
      children: [jsx("path", {
        d: "M19,3V1H17V3H1V23H23V3Zm2,18.18H3V5H17V7h2V5h2Z"
      }), jsx("path", {
        d: "M8.62,16l.58-.48c.36-.32.67-.61.93-.89a5.67,5.67,0,0,0,.65-.82,3.47,3.47,0,0,0,.37-.84,3,3,0,0,0,.13-.93,2.46,2.46,0,0,0-.72-1.86,3,3,0,0,0-2.11-.68,3.92,3.92,0,0,0-1.33.2,2.7,2.7,0,0,0-.9.56,2.91,2.91,0,0,0-.56.82,5.1,5.1,0,0,0-.31,1L7,12.23a1.86,1.86,0,0,1,.51-1,1.51,1.51,0,0,1,.95-.27,1,1,0,0,1,.79.33,1.21,1.21,0,0,1,.3.85,1.88,1.88,0,0,1-.13.72A2.54,2.54,0,0,1,9,13.5a4.84,4.84,0,0,1-.63.7c-.25.24-.54.5-.88.8s-.68.59-1,.87l-1,.87V18h5.75l.18-1.46H8Z"
      }), jsx("path", {
        d: "M17.64,9.71H16.1L12.31,15v1.14H16V18h1.6V16.14h.88l.18-1.34H17.64ZM16,14.8H14l2-2.9Z"
      })]
    }))]
  }))
}));

const Deny = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M149.48-23.72A2.31,2.31,0,0,1,147.16-26a2.3,2.3,0,0,1,2.32-2.29h2.31V-26a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M152.21-28.71v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M154.61-23.72a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M151.79-31a2.3,2.3,0,0,1-2.32,2.29A2.29,2.29,0,0,1,147.16-31a2.29,2.29,0,0,1,2.31-2.28A2.3,2.3,0,0,1,151.79-31",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "deny"
    }, {
      children: [jsx("path", {
        d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z"
      }), jsx("rect", {
        x: "8",
        y: "11",
        width: "8",
        height: "2"
      })]
    }))]
  }))
}));

const Design = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M69.48,96.28a2.29,2.29,0,1,1,0-4.57h2.31V94a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M72.21,91.29V86.72a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M74.61,96.28a2.28,2.28,0,0,1-2.4-2.23V91.71h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M71.79,89a2.32,2.32,0,1,1-2.32-2.28A2.3,2.3,0,0,1,71.79,89",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "design"
    }, {
      children: [jsx("polygon", {
        points: "10.53 16.66 18.47 8.72 15.64 5.9 7.71 13.83 6.26 17.73 6.64 18.1 10.53 16.66"
      }), jsx("path", {
        d: "M1,1V23H23V1ZM21,21H3V3H21Z"
      })]
    }))]
  }))
}));

const Disable = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsx("g", Object.assign({
      id: "disable"
    }, {
      children: jsx("path", {
        d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,2a10,10,0,0,1,9.11,14.11L3.89,6.16A10,10,0,0,1,12,2Zm0,20A10,10,0,0,1,2.89,7.89l17.22,10A10,10,0,0,1,12,22Z"
      })
    }))
  }))
}));

const Document = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M229.48,216.28a2.29,2.29,0,1,1,0-4.57h2.31V214a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M232.21,211.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M234.61,216.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M231.79,209a2.32,2.32,0,1,1-2.32-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsx("g", Object.assign({
      id: "document"
    }, {
      children: jsx("path", {
        d: "M16.41,1H3V23H21V5.59ZM16,3.41,18.59,6H16ZM19,21H5V3h9V8h5Z"
      })
    }))]
  }))
}));

const DocumentIndex = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "documents"
    }, {
      children: [jsx("rect", {
        x: "6",
        y: "11",
        width: "2",
        height: "2"
      }), jsx("rect", {
        x: "6",
        y: "16",
        width: "2",
        height: "2"
      }), jsx("path", {
        d: "M1,1V23H23V1ZM21,21H3V3H21Z"
      }), jsx("rect", {
        x: "6",
        y: "6",
        width: "10",
        height: "2"
      }), jsx("rect", {
        x: "10",
        y: "11",
        width: "8",
        height: "2"
      }), jsx("rect", {
        x: "10",
        y: "16",
        width: "8",
        height: "2"
      })]
    }))
  }))
}));

const Drag = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "Layer_6",
      "data-name": "Layer 6"
    }, {
      children: [jsx("rect", {
        x: "9",
        y: "7",
        width: "2",
        height: "2"
      }), jsx("rect", {
        x: "9",
        y: "11",
        width: "2",
        height: "2"
      }), jsx("rect", {
        x: "9",
        y: "15",
        width: "2",
        height: "2"
      }), jsx("rect", {
        x: "13",
        y: "7",
        width: "2",
        height: "2"
      }), jsx("rect", {
        x: "13",
        y: "11",
        width: "2",
        height: "2"
      }), jsx("rect", {
        x: "13",
        y: "15",
        width: "2",
        height: "2"
      })]
    }))
  }))
}));

const Download = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "download"
    }, {
      children: [jsx("path", {
        d: "M19.44,5.09A8,8,0,0,0,4.06,7a4.49,4.49,0,0,0,.44,9H6V14H4.5A2.5,2.5,0,1,1,6.25,9.72,6,6,0,0,1,12,2a6,6,0,0,1,5.92,5.06A3.68,3.68,0,0,1,18.5,7a3.5,3.5,0,0,1,0,7H18v2h.5a5.5,5.5,0,0,0,.94-10.91Z"
      }), jsx("polygon", {
        points: "13 11 11 11 11 19.17 8 16.17 8 19 12 23 16 19 16 16.17 13 19.17 13 11"
      })]
    }))
  }))
}));

const Duplicate = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M248.48,176.28a2.29,2.29,0,1,1,0-4.57h2.31V174a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M251.21,171.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M253.61,176.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M250.79,169a2.32,2.32,0,1,1-2.32-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsx("g", Object.assign({
      id: "ICONS"
    }, {
      children: jsx("path", {
        d: "M18.41,5H16V1H1V19H8v4H23V9.59ZM18,7.41,20.59,10H18ZM3,17V3H14V5H8V17Zm7,4V7h6v5h5v9Z"
      })
    }))]
  }))
}));

const EditDeny = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M269.48-263.72a2.31,2.31,0,0,1-2.32-2.28,2.3,2.3,0,0,1,2.32-2.29h2.31V-266a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M272.21-268.71v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M274.61-263.72a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M271.79-271a2.3,2.3,0,0,1-2.32,2.29,2.29,2.29,0,0,1-2.31-2.29,2.29,2.29,0,0,1,2.31-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "edit-deny"
    }, {
      children: [jsx("path", {
        d: "M11,18a7,7,0,0,1,.77-3.19L9.09,17.5,6.5,14.91,17.59,3.83l2.58,2.58-5.36,5.36A7,7,0,0,1,18,11l.39,0L23,6.41,17.59,1,3.71,14.87,1.3,22.12l.58.58,7.25-2.41L11,18.39C11,18.26,11,18.13,11,18ZM4.8,19.62l-.42-.42.89-2.69,2.22,2.22Z",
        fill: "#7b7b7e"
      }), jsx("path", {
        d: "M18,12a6,6,0,1,0,6,6A6,6,0,0,0,18,12Zm3,7H15V17h6Z",
        fill: "#db353d"
      })]
    }))]
  }))
}));

const EditTick = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M309.48-263.72a2.31,2.31,0,0,1-2.32-2.28,2.3,2.3,0,0,1,2.32-2.29h2.31V-266a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M312.21-268.71v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M314.61-263.72a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M311.79-271a2.3,2.3,0,0,1-2.32,2.29,2.29,2.29,0,0,1-2.31-2.29,2.29,2.29,0,0,1,2.31-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "edit-tick"
    }, {
      children: [jsx("path", {
        d: "M11,18a7,7,0,0,1,1.18-3.89L8.79,17.5,6.2,14.91,17.29,3.83l2.59,2.58-5.77,5.77A7,7,0,0,1,18,11h.11l4.59-4.6L17.29,1,3.42,14.87,1,22.12l.58.58,7.25-2.41L11,18.11S11,18,11,18ZM4.5,19.62l-.42-.42L5,16.51l2.21,2.22Z",
        fill: "#7b7b7e"
      }), jsx("path", {
        d: "M18,12a6,6,0,1,0,6,6A6,6,0,0,0,18,12Zm.7,9H16.44L14,18h2.58l.88,1.09L19.64,15h2.27Z",
        fill: "#32a31a"
      })]
    }))]
  }))
}));

const Edit = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsx("g", Object.assign({
      id: "edit"
    }, {
      children: jsx("path", {
        d: "M17.44,1.15,3.56,15,1.15,22.27l.58.58L9,20.44,22.85,6.56ZM20,6.56,8.94,17.65,6.35,15.06,17.44,4ZM4.23,19.35l.9-2.69,2.21,2.21-2.69.9Z"
      })
    }))
  }))
}));

const EmailDeny = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "email-deny"
    }, {
      children: [jsx("path", {
        d: "M11,18a6.63,6.63,0,0,1,.08-1H3V3.9L12,12l9-8.1v7.78a7,7,0,0,1,2,1.43V1H1V19H11.08A6.63,6.63,0,0,1,11,18Z",
        fill: "#7b7b7e"
      }), jsx("path", {
        d: "M18,12a6,6,0,1,0,6,6A6,6,0,0,0,18,12Zm3,7H15V17h6Z",
        fill: "#db353d"
      })]
    }))
  }))
}));

const EmailGroup = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M189.48,176.28a2.29,2.29,0,1,1,0-4.57h2.31V174a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M192.21,171.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M194.61,176.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M191.79,169a2.32,2.32,0,1,1-2.32-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "email-group"
    }, {
      children: [jsx("path", {
        d: "M6,7V21H22V7ZM8,19V9.53l5.92,5.39,6-5.39L20,19Z"
      }), jsx("polygon", {
        points: "4.03 5 19 5 19 3 2.02 3 2.02 17 4 17 4.03 5"
      })]
    }))]
  }))
}));

const EmailInvite = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "email-sent"
    }, {
      children: [jsx("path", {
        d: "M11,18a6.63,6.63,0,0,1,.08-1H3V3.9L12,12l9-8.1v7.78a7,7,0,0,1,2,1.43V1H1V19H11.08A6.63,6.63,0,0,1,11,18Z",
        fill: "#7b7b7e"
      }), jsx("path", {
        d: "M18,12a6,6,0,1,0,6,6A6,6,0,0,0,18,12Zm1.83,9H17l2-2H14V17h5l-2-2h2.83l3,3Z",
        fill: "#0066b3"
      })]
    }))
  }))
}));

const EmailTick = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "email-tick"
    }, {
      children: [jsx("path", {
        d: "M11,18a6.63,6.63,0,0,1,.08-1H3V3.9L12,12l9-8.1v7.78a7,7,0,0,1,2,1.43V1H1V19H11.08A6.63,6.63,0,0,1,11,18Z",
        fill: "#7b7b7e"
      }), jsx("path", {
        d: "M18,12a6,6,0,1,0,6,6A6,6,0,0,0,18,12Zm.7,9H16.44L14,18h2.58l.88,1.09L19.64,15h2.27Z",
        fill: "#32a31a"
      })]
    }))
  }))
}));

const Email = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsx("g", Object.assign({
      id: "email"
    }, {
      children: jsx("path", {
        d: "M1,3V21H23V3ZM3,19V5.9L12,14l9-8.1V19Z"
      })
    }))
  }))
}));

const Enable = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M69.48,136.28a2.29,2.29,0,1,1,0-4.57h2.31V134a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M72.21,131.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M74.61,136.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M71.79,129a2.32,2.32,0,1,1-2.32-2.28A2.3,2.3,0,0,1,71.79,129",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "enable"
    }, {
      children: [jsx("path", {
        d: "M1,1V23H23V1ZM21,21H3V3H21Z"
      }), jsx("polygon", {
        points: "11.67 18 18.07 6 15.8 6 10.42 16.09 8.58 13.81 6 13.81 9.4 18 11.67 18"
      })]
    }))]
  }))
}));

const Evaluation = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "Layer_6",
      "data-name": "Layer 6"
    }, {
      children: [jsx("path", {
        d: "M18,12a6,6,0,1,0,6,6A6,6,0,0,0,18,12Zm.7,9H16.44L14,18h2.58l.88,1.09L19.64,15h2.27Z",
        fill: "#1f9c73"
      }), jsx("rect", {
        x: "7",
        y: "8",
        width: "2",
        height: "2",
        fill: "#1f9c73"
      }), jsx("rect", {
        x: "7",
        y: "13",
        width: "2",
        height: "2",
        fill: "#1f9c73"
      }), jsx("rect", {
        x: "7",
        y: "17",
        width: "2",
        height: "2",
        fill: "#1f9c73"
      }), jsx("rect", {
        x: "11",
        y: "8",
        width: "6",
        height: "2",
        fill: "#1f9c73"
      }), jsx("path", {
        d: "M14,3a2,2,0,0,0-4,0H3V23H13.11a6.74,6.74,0,0,1-1.42-2H5V5H7V6H17V5h2v6.08a6.74,6.74,0,0,1,2,.61V3Z",
        fill: "#1f9c73"
      }), jsx("path", {
        d: "M11,15h.72a7,7,0,0,1,1.4-2H11Z",
        fill: "#1f9c73"
      })]
    }))
  }))
}));

const Excel = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "excel"
    }, {
      children: [jsx("path", {
        d: "M1,1V23H23V1ZM21,21H3V3H21Z"
      }), jsx("polygon", {
        points: "9.1 18 11.88 13.64 14.78 18 17.63 18 13.34 11.77 17.16 6.04 14.48 6.04 11.97 9.86 9.5 6.04 6.66 6.04 10.54 11.7 6.37 18 9.1 18"
      })]
    }))
  }))
}));

const ExternalLink = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M189.48,136.28a2.29,2.29,0,1,1,0-4.57h2.31V134a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M192.21,131.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M194.61,136.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M191.79,129a2.32,2.32,0,1,1-2.32-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "external-link"
    }, {
      children: [jsx("polygon", {
        points: "21 21 3 21 3 3 10 3 12 1 1 1 1 23 23 23 23 12 21 14 21 21"
      }), jsx("polygon", {
        points: "16 1 14 3 19.59 3 9.59 13 5 13 5 15 10.41 15 21 4.41 21 10 23 8 23 1 16 1"
      })]
    }))]
  }))
}));

const Hide = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "Layer_6",
      "data-name": "Layer 6"
    }, {
      children: [jsx("rect", {
        x: "0.69",
        y: "11",
        width: "22.63",
        height: "2",
        transform: "translate(-4.97 12) rotate(-45)"
      }), jsx("path", {
        d: "M23.76,13.08A12.31,12.31,0,0,0,21,9.17a12.75,12.75,0,0,0-1.88-1.48L17.69,9.14a10.3,10.3,0,0,1,2,1.46,10.16,10.16,0,0,1,2,2.72,7.83,7.83,0,0,1-1.83,1.35A13.91,13.91,0,0,1,16.37,16c-.2.05-.41.08-.61.12A5.9,5.9,0,0,0,17.5,9.33l-1.61,1.61a3.43,3.43,0,0,1,.06.57,4,4,0,0,1-3.95,4,3.68,3.68,0,0,1-.57-.06L8.67,18.16a21.38,21.38,0,0,0,3.33.26,21,21,0,0,0,4.81-.54,15.37,15.37,0,0,0,4-1.48,9,9,0,0,0,2.83-2.32l.36-.46Z"
      }), jsx("path", {
        d: "M4.25,16.92l1.52-1.51a11.64,11.64,0,0,1-1.63-.74,7.83,7.83,0,0,1-1.83-1.35,10.16,10.16,0,0,1,2-2.72A10.53,10.53,0,0,1,6.69,8.9a5.85,5.85,0,0,0,.13,5.45l1.49-1.49a3.77,3.77,0,0,1-.26-1.35,4,4,0,0,1,3.88-3.95h.14a3.89,3.89,0,0,1,1.28.26L15.18,6a13.64,13.64,0,0,0-2.55-.37c-.2,0-.42,0-.63,0s-.43,0-.63,0A13.36,13.36,0,0,0,7,6.54,13,13,0,0,0,3,9.17,12.31,12.31,0,0,0,.24,13.08L0,13.62l.36.46A9,9,0,0,0,3.19,16.4C3.53,16.59,3.89,16.76,4.25,16.92Z"
      })]
    }))
  }))
}));

const Filter = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M109.48,296.28a2.29,2.29,0,1,1,0-4.57h2.31V294a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M112.21,291.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M114.61,296.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M111.79,289a2.32,2.32,0,1,1-2.32-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "filter"
    }, {
      children: [jsx("rect", {
        x: "11",
        y: "16",
        width: "2",
        height: "2"
      }), jsx("rect", {
        x: "5",
        y: "8",
        width: "14",
        height: "2"
      }), jsx("rect", {
        x: "8",
        y: "12",
        width: "8",
        height: "2"
      }), jsx("path", {
        d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z"
      })]
    }))]
  }))
}));

const FolderEmpty = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M88.48,96.28a2.29,2.29,0,1,1,0-4.57h2.31V94a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M91.21,91.29V86.72a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M93.61,96.28a2.28,2.28,0,0,1-2.4-2.23V91.71h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M90.79,89a2.32,2.32,0,1,1-2.32-2.28A2.3,2.3,0,0,1,90.79,89",
          clipRule: "evenodd"
        })
      }))]
    }), jsx("g", Object.assign({
      id: "folder-empty"
    }, {
      children: jsx("path", {
        d: "M12,7.83,16.17,12,12,16.17,7.83,12,12,7.83M12,5,5,12l7,7,7-7L12,5Z"
      })
    }))]
  }))
}));

const FolderRoot = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M189.48,56.28a2.29,2.29,0,1,1,0-4.57h2.31V54a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M192.21,51.29V46.72a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M194.61,56.28a2.28,2.28,0,0,1-2.4-2.23V51.71h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M191.79,49a2.32,2.32,0,1,1-2.32-2.28A2.3,2.3,0,0,1,191.79,49",
          clipRule: "evenodd"
        })
      }))]
    }), jsx("g", Object.assign({
      id: "folder-root"
    }, {
      children: jsx("path", {
        d: "M9.77,5,8.57,3H1V21H23V5ZM3,5H7.43l1.2,2H21V9H3Z"
      })
    }))]
  }))
}));

const Folder = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsx("g", Object.assign({
      id: "folder"
    }, {
      children: jsx("path", {
        d: "M9.77,5,8.57,3H1V21H23V5ZM7.43,5l1.2,2H21V9H3V5ZM3,19V11H21v8Z"
      })
    }))
  }))
}));

const FormatBoldActive = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "format-bold-active"
    }, {
      children: [jsx("path", {
        d: "M12.5,12.38H10.4v2.91h1.88a3.45,3.45,0,0,0,.92-.1,1.57,1.57,0,0,0,.59-.31,1.13,1.13,0,0,0,.32-.47,2,2,0,0,0,.09-.62,1.39,1.39,0,0,0-.38-1A1.9,1.9,0,0,0,12.5,12.38Z"
      }), jsx("path", {
        d: "M13.57,10.25a1.27,1.27,0,0,0,.33-.94,1,1,0,0,0-.43-.94A2.73,2.73,0,0,0,12,8.09H10.4v2.49h1.95A1.73,1.73,0,0,0,13.57,10.25Z"
      }), jsx("path", {
        d: "M1,1V23H23V1ZM16.15,15.07a2.43,2.43,0,0,1-.67,1,3.43,3.43,0,0,1-1.24.69,6,6,0,0,1-1.89.26H8.24V6.34H12.1a7.2,7.2,0,0,1,2,.22,3.25,3.25,0,0,1,1.22.62,2.06,2.06,0,0,1,.62.91,3.78,3.78,0,0,1,.17,1.14,2.69,2.69,0,0,1-.27,1.19,2.19,2.19,0,0,1-1,.94,4.33,4.33,0,0,1,.79.53,2.39,2.39,0,0,1,.48.6,2.62,2.62,0,0,1,.24.64,3.7,3.7,0,0,1,.07.66A3.86,3.86,0,0,1,16.15,15.07Z"
      })]
    }))
  }))
}));

const FormatBold = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsx("g", Object.assign({
      id: "format-bold"
    }, {
      children: jsx("path", {
        d: "M8.24,6.34H12.1a7.08,7.08,0,0,1,2,.22,3.22,3.22,0,0,1,1.23.62,2.06,2.06,0,0,1,.62.91,3.78,3.78,0,0,1,.17,1.14,2.69,2.69,0,0,1-.27,1.19,2.19,2.19,0,0,1-1,.94,4.33,4.33,0,0,1,.79.53,2.64,2.64,0,0,1,.48.6,2,2,0,0,1,.24.64,3,3,0,0,1,.07.66,3.86,3.86,0,0,1-.21,1.28,2.34,2.34,0,0,1-.67,1,3.35,3.35,0,0,1-1.24.69,6,6,0,0,1-1.89.26H8.24Zm4.11,4.24a1.73,1.73,0,0,0,1.22-.33,1.27,1.27,0,0,0,.33-.94,1,1,0,0,0-.43-.94A2.76,2.76,0,0,0,12,8.09H10.4v2.49Zm-.07,4.71a3.45,3.45,0,0,0,.92-.1,1.57,1.57,0,0,0,.59-.31,1.13,1.13,0,0,0,.32-.47,2,2,0,0,0,.09-.62,1.39,1.39,0,0,0-.38-1,1.9,1.9,0,0,0-1.32-.36H10.4v2.91Z"
      })
    }))
  }))
}));

const FormatItalicActive = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsx("g", Object.assign({
      id: "format-italic-active"
    }, {
      children: jsx("path", {
        d: "M1,1V23H23V1ZM12.67,17.05H10.43L12.7,6.34h2.23Z"
      })
    }))
  }))
}));

const FormatItalic = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsx("g", Object.assign({
      id: "format-italic"
    }, {
      children: jsx("path", {
        d: "M10.43,17.05,12.7,6.34h2.23L12.67,17.05Z"
      })
    }))
  }))
}));

const FormatListActive = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsx("g", Object.assign({
      id: "format-active"
    }, {
      children: jsx("path", {
        d: "M1,1V23H23V1ZM7,17H5V15H7Zm0-4H5V11H7ZM7,9H5V7H7Zm12,8H9V15H19Zm0-4H9V11H19Zm0-4H9V7H19Z"
      })
    }))
  }))
}));

const FormatList = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "format-list"
    }, {
      children: [jsx("rect", {
        x: "5",
        y: "15",
        width: "2",
        height: "2"
      }), jsx("rect", {
        x: "5",
        y: "11",
        width: "2",
        height: "2"
      }), jsx("rect", {
        x: "5",
        y: "7",
        width: "2",
        height: "2"
      }), jsx("rect", {
        x: "9",
        y: "15",
        width: "10",
        height: "2"
      }), jsx("rect", {
        x: "9",
        y: "11",
        width: "10",
        height: "2"
      }), jsx("rect", {
        x: "9",
        y: "7",
        width: "10",
        height: "2"
      })]
    }))
  }))
}));

const FormatUnderlineActive = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsx("g", Object.assign({
      id: "format-underline-active"
    }, {
      children: jsx("path", {
        d: "M1,1V23H23V1ZM16,19H8V18h8Zm.31-7.6a6.39,6.39,0,0,1-.3,2.08,3.8,3.8,0,0,1-.85,1.44,3.36,3.36,0,0,1-1.36.82A5.69,5.69,0,0,1,12,16a5.66,5.66,0,0,1-1.82-.27,3.38,3.38,0,0,1-1.36-.83A3.56,3.56,0,0,1,8,13.45a6.89,6.89,0,0,1-.28-2.1V5H9.92V11.4a3.44,3.44,0,0,0,.48,2,1.86,1.86,0,0,0,1.61.66,1.84,1.84,0,0,0,1.6-.66,3.52,3.52,0,0,0,.47-2V5h2.23Z"
      })
    }))
  }))
}));

const FormatUnderline = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "format-underline"
    }, {
      children: [jsx("rect", {
        x: "8",
        y: "18",
        width: "8",
        height: "1"
      }), jsx("path", {
        d: "M14.08,5V11.4a3.52,3.52,0,0,1-.47,2,1.84,1.84,0,0,1-1.6.66,1.86,1.86,0,0,1-1.61-.66,3.44,3.44,0,0,1-.48-2V5H7.69v6.33A6.89,6.89,0,0,0,8,13.45a3.56,3.56,0,0,0,.84,1.45,3.38,3.38,0,0,0,1.36.83A5.71,5.71,0,0,0,12,16a5.65,5.65,0,0,0,1.81-.26,3.36,3.36,0,0,0,1.36-.82A3.8,3.8,0,0,0,16,13.48a6.39,6.39,0,0,0,.3-2.08V5Z"
      })]
    }))
  }))
}));

const Help = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M229.48-23.72A2.31,2.31,0,0,1,227.16-26a2.3,2.3,0,0,1,2.32-2.29h2.31V-26a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M232.21-28.71v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M234.61-23.72a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M231.79-31a2.3,2.3,0,0,1-2.32,2.29A2.29,2.29,0,0,1,227.16-31a2.29,2.29,0,0,1,2.31-2.28A2.3,2.3,0,0,1,231.79-31",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "help"
    }, {
      children: [jsx("rect", {
        x: "10.94",
        y: "14.77",
        width: "1.93",
        height: "2.23"
      }), jsx("path", {
        d: "M12,6.84a4.21,4.21,0,0,0-1.45.22,3,3,0,0,0-1,.61,3,3,0,0,0-.65.91,4.52,4.52,0,0,0-.35,1.13l1.81.22a1.9,1.9,0,0,1,.55-1.13A1.62,1.62,0,0,1,12,8.47a1.13,1.13,0,0,1,.84.31,1.08,1.08,0,0,1,.32.83,1.68,1.68,0,0,1-.07.52,1.56,1.56,0,0,1-.2.41,2.39,2.39,0,0,1-.28.35l-.35.34-.48.48a5.17,5.17,0,0,0-.42.51,2.19,2.19,0,0,0-.3.59,1.94,1.94,0,0,0-.11.7v.33h1.93V13.6a1.33,1.33,0,0,1,.1-.54,2.27,2.27,0,0,1,.26-.48q.18-.22.39-.45l.48-.48.41-.42a2.87,2.87,0,0,0,.35-.47,2.43,2.43,0,0,0,.24-.59,3.12,3.12,0,0,0,.09-.79,2.28,2.28,0,0,0-.84-1.86A3.63,3.63,0,0,0,12,6.84Z"
      }), jsx("path", {
        d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z"
      })]
    }))]
  }))
}));

const HeartOutline = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsx("g", Object.assign({
      id: "Layer_6",
      "data-name": "Layer 6"
    }, {
      children: jsx("path", {
        d: "M17.46,5a2.45,2.45,0,0,1,1.06.24,2.89,2.89,0,0,1,.91.7,3.73,3.73,0,0,1,.89,2.48,7,7,0,0,1-.71,3.06,10.62,10.62,0,0,1-1.83,2.63A27,27,0,0,1,13,18c-.37.24-.68.45-.94.64-.26-.19-.57-.4-.94-.64a27.49,27.49,0,0,1-4.8-3.86,10.67,10.67,0,0,1-1.84-2.63,7.1,7.1,0,0,1-.71-3.06,3.74,3.74,0,0,1,.9-2.48,2.89,2.89,0,0,1,.91-.7A2.41,2.41,0,0,1,6.61,5a2.45,2.45,0,0,1,1.06.24,2.89,2.89,0,0,1,.91.7,3.74,3.74,0,0,1,.9,2.48A2.65,2.65,0,0,0,12,11.15,2.65,2.65,0,0,0,14.6,8.42a3.74,3.74,0,0,1,.9-2.48,2.78,2.78,0,0,1,.91-.7A2.41,2.41,0,0,1,17.46,5m0-2a4.46,4.46,0,0,0-1.92.44A4.74,4.74,0,0,0,14,4.62a5.73,5.73,0,0,0-1.4,3.8.67.67,0,0,1-.56.73.66.66,0,0,1-.56-.73,5.73,5.73,0,0,0-1.4-3.8A4.67,4.67,0,0,0,8.53,3.44,4.39,4.39,0,0,0,6.61,3a4.46,4.46,0,0,0-1.92.44A4.74,4.74,0,0,0,3.15,4.62a5.73,5.73,0,0,0-1.4,3.8,9.07,9.07,0,0,0,.91,3.92,12.8,12.8,0,0,0,2.17,3.13A28.52,28.52,0,0,0,10,19.62a13.25,13.25,0,0,1,1.58,1.16A.62.62,0,0,0,12,21a.64.64,0,0,0,.48-.22,11.72,11.72,0,0,1,1.58-1.16,28.15,28.15,0,0,0,5.14-4.15,12.58,12.58,0,0,0,2.18-3.13,9.06,9.06,0,0,0,.9-3.92,5.72,5.72,0,0,0-1.39-3.8,4.88,4.88,0,0,0-1.55-1.18A4.39,4.39,0,0,0,17.46,3Z"
      })
    }))
  }))
}));

const HeartSolid = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsx("g", Object.assign({
      id: "Layer_6",
      "data-name": "Layer 6"
    }, {
      children: jsx("path", {
        d: "M12,21a.62.62,0,0,1-.48-.22A13.25,13.25,0,0,0,10,19.62a28.52,28.52,0,0,1-5.15-4.15,12.8,12.8,0,0,1-2.17-3.13,9.07,9.07,0,0,1-.91-3.92,5.73,5.73,0,0,1,1.4-3.8A4.74,4.74,0,0,1,4.69,3.44,4.46,4.46,0,0,1,6.61,3a4.39,4.39,0,0,1,1.92.44,4.67,4.67,0,0,1,1.55,1.18,5.73,5.73,0,0,1,1.4,3.8.66.66,0,0,0,.56.73.67.67,0,0,0,.56-.73A5.73,5.73,0,0,1,14,4.62a4.74,4.74,0,0,1,1.54-1.18A4.46,4.46,0,0,1,17.46,3a4.39,4.39,0,0,1,1.92.44,4.88,4.88,0,0,1,1.55,1.18,5.72,5.72,0,0,1,1.39,3.8,9.06,9.06,0,0,1-.9,3.92,12.58,12.58,0,0,1-2.18,3.13,28.15,28.15,0,0,1-5.14,4.15,11.72,11.72,0,0,0-1.58,1.16A.64.64,0,0,1,12,21Z"
      })
    }))
  }))
}));

const History = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "history"
    }, {
      children: [jsx("path", {
        d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z"
      }), jsx("path", {
        d: "M13,4H11v8s0,.08,0,.12a.65.65,0,0,0,.05.2.89.89,0,0,0,.08.17.86.86,0,0,0,.1.16l.16.13.09.09,5.05,2.91,1-1.73L13,11.42Z"
      })]
    }))
  }))
}));

const Html = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M69.48,216.28a2.29,2.29,0,1,1,0-4.57h2.31V214a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M72.21,211.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M74.61,216.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M71.79,209a2.32,2.32,0,1,1-2.32-2.28A2.3,2.3,0,0,1,71.79,209",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "html"
    }, {
      children: [jsx("path", {
        d: "M1,1V23H23V1ZM21,21H3V3H21Z"
      }), jsx("polygon", {
        points: "15.83 15 18.83 12 15.83 9 13 9 16 12 13 15 15.83 15"
      }), jsx("polygon", {
        points: "11 15 8 12 11 9 8.17 9 5.17 12 8.17 15 11 15"
      })]
    }))]
  }))
}));

const Image = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M109.48,216.28a2.29,2.29,0,1,1,0-4.57h2.31V214a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M112.21,211.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M114.61,216.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M111.79,209a2.32,2.32,0,1,1-2.32-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsx("g", Object.assign({
      id: "image"
    }, {
      children: jsx("path", {
        d: "M1,1V23H23V1ZM21,21H3V20H5V19H4V18H6V17H7V16H9V15H8V14h8v1H15v1h2v1h1v1h2v1H19v1h2ZM8,12a4,4,0,0,1,8,0Zm13,0H18A6,6,0,0,0,6,12H3V3H21Z"
      })
    }))]
  }))
}));

const Information = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M309.48-23.72A2.31,2.31,0,0,1,307.16-26a2.3,2.3,0,0,1,2.32-2.29h2.31V-26a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M312.21-28.71v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M314.61-23.72a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M311.79-31a2.3,2.3,0,0,1-2.32,2.29A2.29,2.29,0,0,1,307.16-31a2.29,2.29,0,0,1,2.31-2.28A2.3,2.3,0,0,1,311.79-31",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "information"
    }, {
      children: [jsx("path", {
        d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z"
      }), jsx("rect", {
        x: "11",
        y: "11",
        width: "2",
        height: "6"
      }), jsx("rect", {
        x: "11",
        y: "7",
        width: "2",
        height: "2"
      })]
    }))]
  }))
}));

const Language = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M-157.59,296.28a2.31,2.31,0,0,1-2.32-2.28,2.3,2.3,0,0,1,2.32-2.29h2.31V294a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M-154.86,291.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M-152.46,296.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M-155.28,289a2.3,2.3,0,0,1-2.32,2.29,2.29,2.29,0,0,1-2.31-2.29,2.29,2.29,0,0,1,2.31-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsx("g", Object.assign({
      id: "language"
    }, {
      children: jsx("path", {
        d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0ZM22,11H19A16.36,16.36,0,0,0,16.75,3.2,10,10,0,0,1,22,11ZM11,2.25V11H7C7.27,6.44,9.08,3.14,11,2.25ZM11,13v8.78c-1.92-.88-3.75-4.2-4-8.77Zm2,8.77V13h4C16.74,17.54,14.92,20.86,13,21.75ZM13,11V2.24c1.91.87,3.74,4.18,4,8.74ZM7.25,3.2A16.41,16.41,0,0,0,5,11h-3A10,10,0,0,1,7.25,3.2ZM2.05,13H5A16.35,16.35,0,0,0,7.25,20.8,10,10,0,0,1,2.05,13Zm14.7,7.81A16.32,16.32,0,0,0,19,13h3A10,10,0,0,1,16.75,20.8Z"
      })
    }))]
  }))
}));

const Link = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M229.48,136.28a2.29,2.29,0,1,1,0-4.57h2.31V134a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M232.21,131.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M234.61,136.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M231.79,129a2.32,2.32,0,1,1-2.32-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "link"
    }, {
      children: [jsx("path", {
        d: "M18.72,2.45a5,5,0,0,0-7.07,0L7.4,6.7a5,5,0,0,0,7.07,7.07l.52-.51a1.92,1.92,0,0,0-1.43-1.41l-.5.5a3.06,3.06,0,0,1-4.24,0,3,3,0,0,1,0-4.24l4.24-4.24A3,3,0,1,1,17.3,8.11l-.77.77a5.89,5.89,0,0,1,.77.65,6,6,0,0,1,.65.77l.77-.78a5,5,0,0,0,0-7.07Z"
      }), jsx("path", {
        d: "M13.06,8.77a5,5,0,0,0-3.53,1.46L9,10.74a2,2,0,0,0,1.42,1.42l.51-.51a3,3,0,1,1,4.24,4.24l-4.24,4.24A3,3,0,0,1,6.7,15.89l.77-.77a5.89,5.89,0,0,1-.77-.65,6.69,6.69,0,0,1-.65-.76l-.77.77a5,5,0,0,0,7.07,7.07L16.6,17.3a5,5,0,0,0-3.54-8.53Z"
      })]
    }))]
  }))
}));

const LogomarkAnsarada = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M168.48-183.72a2.31,2.31,0,0,1-2.32-2.28,2.3,2.3,0,0,1,2.32-2.29h2.31V-186a2.3,2.3,0,0,1-2.31,2.28",
          fill: "none",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M171.21-188.71v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          fill: "none",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M173.61-183.72a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          fill: "none",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M170.79-191a2.3,2.3,0,0,1-2.32,2.29,2.29,2.29,0,0,1-2.31-2.29,2.29,2.29,0,0,1,2.31-2.28,2.3,2.3,0,0,1,2.32,2.28",
          fill: "none",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "Layer_6",
      "data-name": "Layer 6"
    }, {
      children: [jsx("path", {
        d: "M6.8,22A4.65,4.65,0,0,1,2,17.41a4.75,4.75,0,0,1,4.8-4.76h4.61v4.76A4.51,4.51,0,0,1,6.8,22Z",
        fill: "#06ac47"
      }), jsx("path", {
        d: "M12.71,11.22V2A9,9,0,0,1,22,11.22Z",
        fill: "#06ac47"
      }), jsx("path", {
        d: "M17.52,22c-2.66,0-4.81-1.75-4.81-4.37v-5H22V22Z",
        fill: "#06ac47"
      }), jsx("circle", {
        cx: "6.7",
        cy: "6.69",
        r: "4.69",
        fill: "#06ac47"
      })]
    }))]
  }))
}));

const LogomarkKira = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M128.48-183.72a2.31,2.31,0,0,1-2.32-2.28,2.3,2.3,0,0,1,2.32-2.29h2.31V-186a2.3,2.3,0,0,1-2.31,2.28",
          fill: "none",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M131.21-188.71v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          fill: "none",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M133.61-183.72a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          fill: "none",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M130.79-191a2.3,2.3,0,0,1-2.32,2.29,2.29,2.29,0,0,1-2.31-2.29,2.29,2.29,0,0,1,2.31-2.28,2.3,2.3,0,0,1,2.32,2.28",
          fill: "none",
          clipRule: "evenodd"
        })
      }))]
    }), jsx("g", Object.assign({
      id: "Layer_6",
      "data-name": "Layer 6"
    }, {
      children: jsxs("g", Object.assign({
        id: "Group"
      }, {
        children: [jsx("path", {
          id: "Path",
          d: "M6.5,15.8V8.09a1.16,1.16,0,0,1,.55-1C7.22,7,10,5.42,12,4.2c-.93-.55-1.65-.94-1.65-.94a1.08,1.08,0,0,0-1.15,0C7.49,4.26,2.76,7,2.54,7.14a1.14,1.14,0,0,0-.55,1V15.8a1.2,1.2,0,0,0,.61,1.06c1.7,1,6.43,3.71,6.6,3.88a1,1,0,0,0,1.1,0c.38-.22,1-.61,1.7-1-1.59-.94-3.85-2.27-4.95-2.88A1.28,1.28,0,0,1,6.5,15.8Z",
          fill: "#00a651"
        }), jsx("path", {
          id: "Path-2",
          "data-name": "Path",
          d: "M22,8.09a1.16,1.16,0,0,0-.61-1c-.33-.22-6.6-3.83-6.6-3.83a1.08,1.08,0,0,0-1.15,0c-.39.22-1,.55-1.65.94C13.87,5.31,16.73,6.92,17,7.09a1.2,1.2,0,0,1,.6,1V15.8a1.1,1.1,0,0,1-.55,1c-.22.11-2.91,1.72-4.95,2.89.94.55,1.6.94,1.71,1a1,1,0,0,0,1.1,0c1.65-.94,6.38-3.71,6.65-3.88a1.06,1.06,0,0,0,.5-1C22,15.52,22,10,22,8.09Z",
          fill: "#00a651"
        })]
      }))
    }))]
  }))
}));

const ManageDocuments = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M309.48,256.28a2.29,2.29,0,1,1,0-4.57h2.31V254a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M312.21,251.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M314.61,256.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M311.79,249a2.32,2.32,0,1,1-2.32-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "manage-documents"
    }, {
      children: [jsx("rect", {
        x: "6",
        y: "6",
        width: "10",
        height: "2"
      }), jsx("rect", {
        x: "10",
        y: "11",
        width: "8",
        height: "2"
      }), jsx("rect", {
        x: "6",
        y: "11",
        width: "2",
        height: "2"
      }), jsx("rect", {
        x: "6",
        y: "16",
        width: "2",
        height: "2"
      }), jsx("rect", {
        x: "10",
        y: "16",
        width: "8",
        height: "2"
      }), jsx("path", {
        d: "M18.41,1H1V23H23V5.59ZM21,21H3V3H17.59L21,6.41Z"
      })]
    }))]
  }))
}));

const ManageUser = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M229.48,256.28a2.29,2.29,0,1,1,0-4.57h2.31V254a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M232.21,251.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M234.61,256.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M231.79,249a2.32,2.32,0,1,1-2.32-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "manage-users"
    }, {
      children: [jsx("path", {
        d: "M12,16c3.87,0,7-3.58,7-8s-3.13-8-7-8S5,3.58,5,8,8.13,16,12,16ZM7,8c0-3.31,2.24-6,5-6s5,2.69,5,6-2.24,6-5,6S7,11.31,7,8Z"
      }), jsx("polygon", {
        points: "5 16 12 16 19 16 23 23 3 23 5 16"
      })]
    }))]
  }))
}));

const MenuContextual = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M189.48,296.28a2.29,2.29,0,1,1,0-4.57h2.31V294a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M192.21,291.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M194.61,296.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M191.79,289a2.32,2.32,0,1,1-2.32-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "menu-contextual"
    }, {
      children: [jsx("rect", {
        x: "10",
        y: "17",
        width: "4",
        height: "2"
      }), jsx("rect", {
        x: "10",
        y: "5",
        width: "4",
        height: "2"
      }), jsx("rect", {
        x: "10",
        y: "11",
        width: "4",
        height: "2"
      })]
    }))]
  }))
}));

const Menu = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M229.48,296.28a2.29,2.29,0,1,1,0-4.57h2.31V294a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M232.21,291.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M234.61,296.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M231.79,289a2.32,2.32,0,1,1-2.32-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "menu"
    }, {
      children: [jsx("rect", {
        x: "3",
        y: "17",
        width: "18",
        height: "2"
      }), jsx("rect", {
        x: "3",
        y: "5",
        width: "18",
        height: "2"
      }), jsx("rect", {
        x: "3",
        y: "11",
        width: "18",
        height: "2"
      })]
    }))]
  }))
}));

const Move = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M269.48,96.28a2.29,2.29,0,1,1,0-4.57h2.31V94a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M272.21,91.29V86.72a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M274.61,96.28a2.28,2.28,0,0,1-2.4-2.23V91.71h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M271.79,89a2.32,2.32,0,1,1-2.32-2.28A2.3,2.3,0,0,1,271.79,89",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "move"
    }, {
      children: [jsx("path", {
        d: "M6,1V19H23V1ZM21,17H8V3H21Z"
      }), jsx("rect", {
        x: "14",
        y: "21",
        width: "2",
        height: "2"
      }), jsx("rect", {
        x: "10",
        y: "21",
        width: "2",
        height: "2"
      }), jsx("rect", {
        x: "6",
        y: "21",
        width: "2",
        height: "2"
      }), jsx("rect", {
        x: "2",
        y: "21",
        width: "2",
        height: "2"
      }), jsx("rect", {
        x: "2",
        y: "17",
        width: "2",
        height: "2"
      }), jsx("rect", {
        x: "2",
        y: "13",
        width: "2",
        height: "2"
      }), jsx("rect", {
        x: "2",
        y: "9",
        width: "2",
        height: "2"
      }), jsx("rect", {
        x: "2",
        y: "5",
        width: "2",
        height: "2"
      })]
    }))]
  }))
}));

const Notification = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M109.48,256.28a2.29,2.29,0,1,1,0-4.57h2.31V254a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M112.21,251.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M114.61,256.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M111.79,249a2.32,2.32,0,1,1-2.32-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsx("g", Object.assign({
      id: "notifications"
    }, {
      children: jsx("path", {
        d: "M22,18.9A8.73,8.73,0,0,0,20.5,15,8.49,8.49,0,0,1,19,10a7,7,0,0,0-6-6.92V1H11V3.08A7,7,0,0,0,5,10a8.49,8.49,0,0,1-1.5,5,8.73,8.73,0,0,0-1.45,3.9L1.94,20H9.18a3,3,0,0,0,5.64,0h7.24ZM4.25,18a8.58,8.58,0,0,1,1-2A10.53,10.53,0,0,0,7,10a5,5,0,0,1,10,0,10.44,10.44,0,0,0,1.79,6,8.55,8.55,0,0,1,1,2Z"
      })
    }))]
  }))
}));

const Number = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M189.48,96.28a2.29,2.29,0,1,1,0-4.57h2.31V94a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M192.21,91.29V86.72a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M194.61,96.28a2.28,2.28,0,0,1-2.4-2.23V91.71h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M191.79,89a2.32,2.32,0,1,1-2.32-2.28A2.3,2.3,0,0,1,191.79,89",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "number"
    }, {
      children: [jsx("path", {
        d: "M1,1V23H23V1ZM21,21H3V3H21Z"
      }), jsx("path", {
        d: "M8.42,16.22a2.84,2.84,0,0,0,2.35-1.06,5.3,5.3,0,0,0,.83-3.31,5.39,5.39,0,0,0-.82-3.31A2.75,2.75,0,0,0,8.47,7.48a3.27,3.27,0,0,0-1.32.26,2.56,2.56,0,0,0-1,.8A3.82,3.82,0,0,0,5.51,9.9a7.94,7.94,0,0,0-.22,1.95,5.44,5.44,0,0,0,.82,3.31A2.78,2.78,0,0,0,8.42,16.22Zm-1.3-5.59a3.1,3.1,0,0,1,.23-.91,1.38,1.38,0,0,1,.43-.58,1.06,1.06,0,0,1,.66-.2,1.1,1.1,0,0,1,.66.2,1.4,1.4,0,0,1,.44.58,3.43,3.43,0,0,1,.24.91,8.92,8.92,0,0,1,.07,1.22,9,9,0,0,1-.07,1.22,3.54,3.54,0,0,1-.24.91,1.36,1.36,0,0,1-.44.57,1,1,0,0,1-.66.2,1,1,0,0,1-.66-.2A1.35,1.35,0,0,1,7.35,14a3.18,3.18,0,0,1-.23-.91A8.92,8.92,0,0,1,7,11.85,8.81,8.81,0,0,1,7.12,10.63Z"
      }), jsx("path", {
        d: "M15.59,14.76a1.25,1.25,0,0,1-.94-.3,1.51,1.51,0,0,1-.33-.87H12.64a2.6,2.6,0,0,0,.84,2,3.32,3.32,0,0,0,2.18.65A3.57,3.57,0,0,0,16.82,16a2.29,2.29,0,0,0,.89-.56,2.54,2.54,0,0,0,.58-.92,3.8,3.8,0,0,0,.2-1.27,3.6,3.6,0,0,0-.15-1,2.31,2.31,0,0,0-1.28-1.46,2.94,2.94,0,0,0-1.17-.22,3.23,3.23,0,0,0-.73.09,2.17,2.17,0,0,0-.69.28l.16-1.76H18V7.71H13.22l-.4,4.77h1.41a1.83,1.83,0,0,1,.55-.42,1.91,1.91,0,0,1,.76-.14,1.28,1.28,0,0,1,1,.33,1.47,1.47,0,0,1,.31,1,1.59,1.59,0,0,1-.33,1.13A1.18,1.18,0,0,1,15.59,14.76Z"
      })]
    }))]
  }))
}));

const Item = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M-158.54,176.28a2.31,2.31,0,0,1-2.33-2.28,2.3,2.3,0,0,1,2.33-2.29h2.3V174a2.3,2.3,0,0,1-2.3,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M-155.82,171.29v-4.57a4.48,4.48,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M-153.42,176.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M-156.24,169a2.29,2.29,0,0,1-2.31,2.29,2.3,2.3,0,0,1-2.32-2.29,2.3,2.3,0,0,1,2.32-2.28,2.29,2.29,0,0,1,2.31,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "Layer_6",
      "data-name": "Layer 6"
    }, {
      children: [jsx("rect", {
        x: "5.97",
        y: "6",
        width: "2",
        height: "2"
      }), jsx("rect", {
        x: "5.97",
        y: "11",
        width: "2",
        height: "2"
      }), jsx("path", {
        d: "M1,1V23H23V1ZM21,21H3V3H21Z"
      }), jsx("rect", {
        x: "9.97",
        y: "6",
        width: "8",
        height: "2"
      }), jsx("rect", {
        x: "9.97",
        y: "11",
        width: "8",
        height: "2"
      })]
    }))]
  }))
}));

const Pin = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    id: "Layer_133",
    "data-name": "Layer 133",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M69.48,256.28a2.29,2.29,0,1,1,0-4.57h2.31V254a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M72.21,251.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M74.61,256.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M71.79,249a2.32,2.32,0,1,1-2.32-2.28A2.3,2.3,0,0,1,71.79,249",
          clipRule: "evenodd"
        })
      }))]
    }), jsx("path", {
      d: "M12,3a6.81,6.81,0,0,1,6.8,6.8c0,3.11-3.76,7.67-6.79,10.52C9.41,17.86,5.2,13.17,5.2,9.8A6.81,6.81,0,0,1,12,3m0-2A8.8,8.8,0,0,0,3.2,9.8C3.2,15.65,12,23,12,23s8.8-7.35,8.8-13.2A8.8,8.8,0,0,0,12,1Z"
    }), jsx("path", {
      d: "M12,8a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-2a4,4,0,1,0,4,4,4,4,0,0,0-4-4Z"
    })]
  }))
}));

const Plus = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "plus"
    }, {
      children: [jsx("path", {
        d: "M20.49,3.51a12,12,0,1,0,0,17A12,12,0,0,0,20.49,3.51ZM19.07,19.07a10,10,0,1,1,0-14.14A10,10,0,0,1,19.07,19.07Z"
      }), jsx("polygon", {
        points: "13 5 11 5 11 11 5 11 5 13 11 13 11 19 13 19 13 13 19 13 19 11 13 11 13 5"
      })]
    }))
  }))
}));

const Powerpoint = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M309.48,216.28a2.29,2.29,0,1,1,0-4.57h2.31V214a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M312.21,211.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M314.61,216.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M311.79,209a2.32,2.32,0,1,1-2.32-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "powerpoint"
    }, {
      children: [jsx("path", {
        d: "M1,1V23H23V1ZM21,21H3V3H21Z"
      }), jsx("path", {
        d: "M10.46,13.73h1.88a6.68,6.68,0,0,0,2.22-.32,3.66,3.66,0,0,0,1.4-.86,2.92,2.92,0,0,0,.74-1.27,5.33,5.33,0,0,0,.21-1.5,4.74,4.74,0,0,0-.21-1.42A2.72,2.72,0,0,0,16,7.17a3.8,3.8,0,0,0-1.42-.82A7,7,0,0,0,12.27,6H8V18h2.46Zm0-5.63h1.78a4.13,4.13,0,0,1,1.08.12,1.88,1.88,0,0,1,.68.33,1.3,1.3,0,0,1,.35.54,2.37,2.37,0,0,1,.1.74,2.94,2.94,0,0,1-.09.74,1.2,1.2,0,0,1-.35.58,1.63,1.63,0,0,1-.68.37,3.62,3.62,0,0,1-1.08.13H10.46Z"
      })]
    }))]
  }))
}));

const PrintDeny = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M109.48-263.72a2.31,2.31,0,0,1-2.32-2.28,2.3,2.3,0,0,1,2.32-2.29h2.31V-266a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M112.21-268.71v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M114.61-263.72a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M111.79-271a2.3,2.3,0,0,1-2.32,2.29,2.29,2.29,0,0,1-2.31-2.29,2.29,2.29,0,0,1,2.31-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "print-deny"
    }, {
      children: [jsx("path", {
        d: "M22.89,23H23v-.11Z",
        fill: "#7b7b7e"
      }), jsx("path", {
        d: "M11.68,21H3V10H5v5h6.68a7,7,0,0,1,1.43-2H7V3h5V8h5v3.08a6.29,6.29,0,0,1,2,0V10h2v1.68a7,7,0,0,1,2,1.43V8H19V5.59L14.41,1H5V8H1V23H13.11A7,7,0,0,1,11.68,21ZM14,3.41,16.59,6H14Z",
        fill: "#7b7b7e"
      }), jsx("path", {
        d: "M18,12a6,6,0,1,0,6,6A6,6,0,0,0,18,12Zm3,7H15V17h6Z",
        fill: "#db353d"
      })]
    }))]
  }))
}));

const PrintTick = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M149.48-263.72a2.31,2.31,0,0,1-2.32-2.28,2.3,2.3,0,0,1,2.32-2.29h2.31V-266a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M152.21-268.71v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M154.61-263.72a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M151.79-271a2.3,2.3,0,0,1-2.32,2.29,2.29,2.29,0,0,1-2.31-2.29,2.29,2.29,0,0,1,2.31-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "print-tick"
    }, {
      children: [jsx("path", {
        d: "M11.68,21H3V10H5v5h6.68a7,7,0,0,1,1.43-2H7V3h5V8h5v3.08a6.29,6.29,0,0,1,2,0V10h2v1.68a7,7,0,0,1,2,1.43V8H19V5.59L14.41,1H5V8H1V23H13.11A7,7,0,0,1,11.68,21ZM14,3.41,16.59,6H14Z",
        fill: "#7b7b7e"
      }), jsx("path", {
        d: "M22.89,23H23v-.11Z",
        fill: "#7b7b7e"
      }), jsx("path", {
        d: "M18,12a6,6,0,1,0,6,6A6,6,0,0,0,18,12Zm.7,9H16.44L14,18h2.58l.88,1.09L19.64,15h2.27Z",
        fill: "#32a31a"
      })]
    }))]
  }))
}));

const Print = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M149.48,136.28a2.29,2.29,0,1,1,0-4.57h2.31V134a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M152.21,131.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M154.61,136.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M151.79,129a2.32,2.32,0,1,1-2.32-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "print"
    }, {
      children: [jsx("path", {
        d: "M19,8V5.59L14.41,1H5V8H1V23H23V8ZM16.59,6H14V3.41ZM7,3h5V8h5v5H7ZM21,21H3V10H5v5H19V10h2Z"
      }), jsx("rect", {
        x: "17",
        y: "17",
        width: "2",
        height: "2"
      })]
    }))]
  }))
}));

const PriorityHigh = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "priority-high"
    }, {
      children: [jsx("rect", {
        x: "11",
        y: "7",
        width: "2",
        height: "6"
      }), jsx("rect", {
        x: "11",
        y: "15",
        width: "2",
        height: "2"
      }), jsx("rect", {
        x: "15",
        y: "7",
        width: "2",
        height: "6"
      }), jsx("rect", {
        x: "15",
        y: "15",
        width: "2",
        height: "2"
      }), jsx("rect", {
        x: "7",
        y: "7",
        width: "2",
        height: "6"
      }), jsx("rect", {
        x: "7",
        y: "15",
        width: "2",
        height: "2"
      })]
    }))
  }))
}));

const PriorityLow = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M269.48-63.72A2.31,2.31,0,0,1,267.16-66a2.3,2.3,0,0,1,2.32-2.29h2.31V-66a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M272.21-68.71v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M274.61-63.72a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M271.79-71a2.3,2.3,0,0,1-2.32,2.29A2.29,2.29,0,0,1,267.16-71a2.29,2.29,0,0,1,2.31-2.28A2.3,2.3,0,0,1,271.79-71",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "priority-low"
    }, {
      children: [jsx("rect", {
        x: "11",
        y: "7",
        width: "2",
        height: "6"
      }), jsx("rect", {
        x: "11",
        y: "15",
        width: "2",
        height: "2"
      })]
    }))]
  }))
}));

const PriorityMedium = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M309.48-63.72A2.31,2.31,0,0,1,307.16-66a2.3,2.3,0,0,1,2.32-2.29h2.31V-66a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M312.21-68.71v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M314.61-63.72a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M311.79-71a2.3,2.3,0,0,1-2.32,2.29A2.29,2.29,0,0,1,307.16-71a2.29,2.29,0,0,1,2.31-2.28A2.3,2.3,0,0,1,311.79-71",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "priority-medium"
    }, {
      children: [jsx("rect", {
        x: "9",
        y: "7",
        width: "2",
        height: "6"
      }), jsx("rect", {
        x: "9",
        y: "15",
        width: "2",
        height: "2"
      }), jsx("rect", {
        x: "13",
        y: "7",
        width: "2",
        height: "6"
      }), jsx("rect", {
        x: "13",
        y: "15",
        width: "2",
        height: "2"
      })]
    }))]
  }))
}));

const QnAActions = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M189.48,16.28a2.29,2.29,0,1,1,0-4.57h2.31V14a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M192.21,11.29V6.72a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M194.61,16.28a2.28,2.28,0,0,1-2.4-2.23V11.71h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M191.79,9a2.32,2.32,0,1,1-2.32-2.28A2.3,2.3,0,0,1,191.79,9",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "QnA-actions"
    }, {
      children: [jsx("path", {
        d: "M22,2H2V21h8.5L12,24l1.5-3H22ZM20,19H4V4H20Z"
      }), jsx("polygon", {
        points: "9.65 17 10.99 17 17.41 10.5 11.41 10.5 14.35 6 13.01 6 6.59 12.5 12.59 12.5 9.65 17"
      })]
    }))]
  }))
}));

const QnAAnswer = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "QnA-answer"
    }, {
      children: [jsx("path", {
        d: "M22,2H2V21h8.5L12,24l1.5-3H22ZM20,19H4V4H20Z"
      }), jsx("path", {
        d: "M10.21,13.69h3.5l.8,2.31h2.24L13,6H11L7.25,16H9.41Zm1.73-5.31L13.16,12H10.74Z"
      })]
    }))
  }))
}));

const QnAComment = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M69.48,16.28a2.29,2.29,0,1,1,0-4.57h2.31V14a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M72.21,11.29V6.72a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M74.61,16.28a2.28,2.28,0,0,1-2.4-2.23V11.71h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M71.79,9a2.32,2.32,0,1,1-2.32-2.28A2.3,2.3,0,0,1,71.79,9",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "QnA-comment"
    }, {
      children: [jsx("path", {
        d: "M2,2V21h8.5L12,24l1.5-3H22V2ZM20,19H4V4H20Z"
      }), jsx("rect", {
        x: "7",
        y: "13",
        width: "2",
        height: "2"
      }), jsx("rect", {
        x: "11",
        y: "13",
        width: "2",
        height: "2"
      }), jsx("rect", {
        x: "15",
        y: "13",
        width: "2",
        height: "2"
      })]
    }))]
  }))
}));

const QnAForward = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M309.48,16.28a2.29,2.29,0,1,1,0-4.57h2.31V14a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M312.21,11.29V6.72a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M314.61,16.28a2.28,2.28,0,0,1-2.4-2.23V11.71h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M311.79,9a2.32,2.32,0,1,1-2.32-2.28A2.3,2.3,0,0,1,311.79,9",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "QnA-forward"
    }, {
      children: [jsx("path", {
        d: "M22,2H2V21h8.5L12,24l1.5-3H22ZM20,19H4V4H20Z"
      }), jsx("path", {
        d: "M15,10.41v4.25l2-2V7H11.34l-2,2h4.25l-5,5H7v2H9.41ZM15,9Z"
      })]
    }))]
  }))
}));

const QnAManage = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M269.48,256.28a2.29,2.29,0,1,1,0-4.57h2.31V254a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M272.21,251.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M274.61,256.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M271.79,249a2.32,2.32,0,1,1-2.32-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "QnA-manage"
    }, {
      children: [jsx("path", {
        d: "M17.69,12a8.13,8.13,0,0,0-.39-2.61,5.79,5.79,0,0,0-1.11-2A4.77,4.77,0,0,0,14.4,6.17,6.21,6.21,0,0,0,12,5.74a6.19,6.19,0,0,0-2.38.43,5,5,0,0,0-1.8,1.26,5.53,5.53,0,0,0-1.14,2A8.13,8.13,0,0,0,6.3,12a8.13,8.13,0,0,0,.39,2.61,5.66,5.66,0,0,0,1.13,2,4.85,4.85,0,0,0,1.79,1.26,6.26,6.26,0,0,0,2.4.43,6.1,6.1,0,0,0,2.58-.52l1.52,1.88,1.51-1.27-1.46-1.8a5.24,5.24,0,0,0,1.14-1.95A8.11,8.11,0,0,0,17.69,12ZM14.6,14.67,13.25,13l-1.51,1.27L13.2,16a2.65,2.65,0,0,1-.57.15c-.2,0-.41,0-.62,0a2.71,2.71,0,0,1-2.36-1.1A5.34,5.34,0,0,1,8.88,12,5.24,5.24,0,0,1,9.65,9,2.72,2.72,0,0,1,12,7.88,2.64,2.64,0,0,1,14.34,9,5.24,5.24,0,0,1,15.11,12,5.7,5.7,0,0,1,14.6,14.67Z"
      }), jsx("path", {
        d: "M18.41,1H1V23H23V5.59ZM21,21H3V3H17.59L21,6.41Z"
      })]
    }))]
  }))
}));

const QnAQuestion = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "QnA-question"
    }, {
      children: [jsx("path", {
        d: "M22,2H2V21h8.5L12,24l1.5-3H22ZM20,19H4V4H20Z"
      }), jsx("path", {
        d: "M8.51,14.84A4.11,4.11,0,0,0,10,15.89a5.21,5.21,0,0,0,2,.36,5.1,5.1,0,0,0,2.15-.43l1.28,1.57,1.26-1.07-1.22-1.5a4.26,4.26,0,0,0,.95-1.63A6.73,6.73,0,0,0,16.75,11a6.71,6.71,0,0,0-.32-2.18,4.44,4.44,0,0,0-.93-1.65,4,4,0,0,0-1.49-1,5.09,5.09,0,0,0-2-.37,5,5,0,0,0-2,.37,4.11,4.11,0,0,0-1.51,1,4.61,4.61,0,0,0-1,1.65A6.7,6.7,0,0,0,7.23,11a6.81,6.81,0,0,0,.33,2.19A4.79,4.79,0,0,0,8.51,14.84ZM10,8.45a2.27,2.27,0,0,1,2-.91,2.24,2.24,0,0,1,2,.91A4.4,4.4,0,0,1,14.6,11a4.77,4.77,0,0,1-.42,2.21L13,11.79l-1.26,1.06L13,14.35a3.59,3.59,0,0,1-.47.12,4.53,4.53,0,0,1-.52,0,2.23,2.23,0,0,1-2-.92A4.43,4.43,0,0,1,9.39,11,4.33,4.33,0,0,1,10,8.45Z"
      })]
    }))
  }))
}));

const QnASubjectGroup = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M229.48,16.28a2.29,2.29,0,1,1,0-4.57h2.31V14a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M232.21,11.29V6.72a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M234.61,16.28a2.28,2.28,0,0,1-2.4-2.23V11.71h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M231.79,9a2.32,2.32,0,1,1-2.32-2.28A2.3,2.3,0,0,1,231.79,9",
          clipRule: "evenodd"
        })
      }))]
    }), jsx("g", Object.assign({
      id: "QnA-subject-group"
    }, {
      children: jsx("path", {
        d: "M22,4H10.77L9.57,2H2V21h8.5L12,24l1.5-3H22ZM8.43,4l1.2,2H20V8H4V4ZM4,19V10H20v9Z"
      })
    }))]
  }))
}));

const QnASubject = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M248.48,16.28a2.29,2.29,0,1,1,0-4.57h2.31V14a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M251.21,11.29V6.72a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M253.61,16.28a2.28,2.28,0,0,1-2.4-2.23V11.71h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M250.79,9a2.32,2.32,0,1,1-2.32-2.28A2.3,2.3,0,0,1,250.79,9",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "ICONS"
    }, {
      children: [jsx("path", {
        d: "M22,2H2V21h8.5L12,24l1.5-3H22ZM20,19H4V4H20Z"
      }), jsx("rect", {
        x: "7",
        y: "7",
        width: "10",
        height: "2"
      }), jsx("rect", {
        x: "7",
        y: "11",
        width: "8",
        height: "2"
      })]
    }))]
  }))
}));

const QnATick = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "QnA-approve"
    }, {
      children: [jsx("path", {
        d: "M22,2H2V21h8.5L12,24l1.5-3H22ZM20,19H4V4H20Z"
      }), jsx("polygon", {
        points: "12.26 15.14 16.67 6.86 14.41 6.86 11.01 13.22 9.9 11.86 7.33 11.86 9.99 15.14 12.26 15.14"
      })]
    }))
  }))
}));

const QnAViewer = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M88.48,16.28a2.29,2.29,0,1,1,0-4.57h2.31V14a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M91.21,11.29V6.72a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M93.61,16.28a2.28,2.28,0,0,1-2.4-2.23V11.71h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M90.79,9a2.32,2.32,0,1,1-2.32-2.28A2.3,2.3,0,0,1,90.79,9",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "ICONS"
    }, {
      children: [jsx("path", {
        d: "M22,2H2V21h8.5L12,24l1.5-3H22ZM20,19H4V4H20Z"
      }), jsx("path", {
        d: "M12,8a3.5,3.5,0,1,1-3.5,3.5A3.5,3.5,0,0,1,12,8m0-2a5.5,5.5,0,1,0,5.5,5.5A5.5,5.5,0,0,0,12,6Z"
      })]
    }))]
  }))
}));

const RedactArea = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "Layer_6",
      "data-name": "Layer 6"
    }, {
      children: [jsx("path", {
        d: "M1,1V23H23V1ZM21,21H3V3H21Z"
      }), jsx("rect", {
        x: "5.97",
        y: "5",
        width: "11",
        height: "2"
      }), jsx("rect", {
        x: "5.97",
        y: "17",
        width: "10",
        height: "2"
      }), jsx("rect", {
        x: "4.97",
        y: "12",
        width: "8",
        height: "3"
      }), jsx("rect", {
        x: "4.97",
        y: "9",
        width: "14",
        height: "4"
      })]
    }))
  }))
}));

const RedactPage = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "Layer_6",
      "data-name": "Layer 6"
    }, {
      children: [jsx("path", {
        d: "M16,1H1V23H23V8Zm.34,3.17L20.14,8H16.31ZM3,21V3H14.31v7H21V21Z"
      }), jsx("polygon", {
        points: "5 5 15.31 5 15.31 9 19 9 19 19 5 19 5 5"
      })]
    }))
  }))
}));

const RedactPattern = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "Layer_6",
      "data-name": "Layer 6"
    }, {
      children: [jsx("path", {
        d: "M1,1V23H23V1ZM21,21H3V3H21Z"
      }), jsx("rect", {
        x: "4.97",
        y: "5",
        width: "8",
        height: "3"
      }), jsx("rect", {
        x: "10.97",
        y: "10",
        width: "8",
        height: "3"
      }), jsx("rect", {
        x: "6.97",
        y: "15",
        width: "8",
        height: "3"
      })]
    }))
  }))
}));

const RedactText = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "Layer_6",
      "data-name": "Layer 6"
    }, {
      children: [jsx("path", {
        d: "M22.78,18.2,15.3,10.72h0a.8.8,0,0,0-.21-.15L13.71,10H21V8H10.85l-.55-.47a1,1,0,0,0-.92-.15A.69.69,0,0,0,9,8v3.19a.67.67,0,0,0,.2.47l.51.32.44,1H3v2h8.16l.9,1,1,1H3v2H15l.33.33,1.33,1.34,1.8,1.8a.65.65,0,0,0,.94,0l3.34-3.33A.66.66,0,0,0,22.78,18.2ZM11.72,13.35,11,11.76l1-1,1.6.68ZM19,21.06,15,17.11,15,17h-.05l-2.48-2.47,2.39-2.39,6.53,6.53Z"
      }), jsx("rect", {
        x: "2.97",
        y: "3",
        width: "16",
        height: "2"
      }), jsx("rect", {
        x: "1.97",
        y: "7",
        width: "6",
        height: "4"
      })]
    }))
  }))
}));

const Redact = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "Layer_6",
      "data-name": "Layer 6"
    }, {
      children: [jsx("rect", {
        x: "4.97",
        y: "3",
        width: "14",
        height: "2"
      }), jsx("rect", {
        x: "4.97",
        y: "13",
        width: "14",
        height: "2"
      }), jsx("rect", {
        x: "4.97",
        y: "17",
        width: "12",
        height: "2"
      }), jsx("rect", {
        x: "2.97",
        y: "7",
        width: "18",
        height: "4"
      })]
    }))
  }))
}));

const Report = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "reports"
    }, {
      children: [jsx("path", {
        d: "M1,1V23H23V1ZM21,21H3V3H21Z"
      }), jsx("rect", {
        x: "6",
        y: "11",
        width: "2",
        height: "7"
      }), jsx("rect", {
        x: "11",
        y: "9",
        width: "2",
        height: "9"
      }), jsx("rect", {
        x: "16",
        y: "6",
        width: "2",
        height: "12"
      })]
    }))
  }))
}));

const Revert = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "revert"
    }, {
      children: [jsx("path", {
        d: "M1,1V23H23V1ZM21,21H3V3H21Z"
      }), jsx("path", {
        d: "M12.83,14l-3-3H13.5a2.5,2.5,0,0,1,1.77,4.27l-.71.7L16,17.39l.71-.71A4.5,4.5,0,0,0,13.5,9H9.83l3-3H10L6,10l4,4Z"
      })]
    }))
  }))
}));

const SaveDeny = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M189.48-263.72a2.31,2.31,0,0,1-2.32-2.28,2.3,2.3,0,0,1,2.32-2.29h2.31V-266a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M192.21-268.71v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M194.61-263.72a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M191.79-271a2.3,2.3,0,0,1-2.32,2.29,2.29,2.29,0,0,1-2.31-2.29,2.29,2.29,0,0,1,2.31-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "save-deny"
    }, {
      children: [jsx("path", {
        d: "M13.11,23H3.59L1,20.41V1H23V13.11a7,7,0,0,0-2-1.43V3H19v8.08A6.63,6.63,0,0,0,18,11a6.94,6.94,0,0,0-3.59,1H5V3H3V19.59L4.41,21H6V14h6.26a7.13,7.13,0,0,0-1,2H8v5h3.68A7,7,0,0,0,13.11,23Zm9.78,0H23v-.11ZM9,20h2V17H9Z",
        fill: "#7b7b7e"
      }), jsx("path", {
        d: "M18,12a6,6,0,1,0,6,6A6,6,0,0,0,18,12Zm3,7H15V17h6Z",
        fill: "#db353d"
      })]
    }))]
  }))
}));

const SaveTick = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M229.48-263.72a2.31,2.31,0,0,1-2.32-2.28,2.3,2.3,0,0,1,2.32-2.29h2.31V-266a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M232.21-268.71v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M234.61-263.72a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M231.79-271a2.3,2.3,0,0,1-2.32,2.29,2.29,2.29,0,0,1-2.31-2.29,2.29,2.29,0,0,1,2.31-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "save-tick"
    }, {
      children: [jsx("path", {
        d: "M13.11,23H3.59L1,20.41V1H23V13.11a7,7,0,0,0-2-1.43V3H19v8.08A6.63,6.63,0,0,0,18,11a6.94,6.94,0,0,0-3.59,1H5V3H3V19.59L4.41,21H6V14h6.26a7.13,7.13,0,0,0-1,2H8v5h3.68A7,7,0,0,0,13.11,23Zm9.78,0H23v-.11ZM9,20h2V17H9Z",
        fill: "#7b7b7e"
      }), jsx("path", {
        d: "M18,12a6,6,0,1,0,6,6A6,6,0,0,0,18,12Zm.7,9H16.44L14,18h2.58l.88,1.09L19.64,15h2.27Z",
        fill: "#32a31a"
      })]
    }))]
  }))
}));

const Save = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M109.48,136.28a2.29,2.29,0,1,1,0-4.57h2.31V134a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M112.21,131.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M114.61,136.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M111.79,129a2.32,2.32,0,1,1-2.32-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "save"
    }, {
      children: [jsx("rect", {
        x: "9",
        y: "17",
        width: "2",
        height: "3"
      }), jsx("path", {
        d: "M1,1V20.41L3.59,23H23V1ZM8,21V16h9v5Zm13,0H19V14H6v7H4.41L3,19.59V3H5v9H19V3h2Z"
      })]
    }))]
  }))
}));

const Scorecards = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "scorecards"
    }, {
      children: [jsx("path", {
        d: "M1,1V23H23V1ZM21,3V5H3V3ZM3,21V7H21V21Z"
      }), jsx("polygon", {
        points: "10.85 15.36 9.75 14 7.17 14 9.83 17.28 12.1 17.28 16.51 9 14.25 9 10.85 15.36"
      })]
    }))
  }))
}));

const Search = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M269.48,296.28a2.29,2.29,0,1,1,0-4.57h2.31V294a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M272.21,291.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M274.61,296.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M271.79,289a2.32,2.32,0,1,1-2.32-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsx("g", Object.assign({
      id: "search"
    }, {
      children: jsx("path", {
        d: "M23,21.63l-7.7-7.7a8,8,0,1,0-1.37,1.37l7.7,7.7ZM9,15a6,6,0,1,1,6-6A6,6,0,0,1,9,15Z"
      })
    }))]
  }))
}));

const Secure = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M189.48,256.28a2.29,2.29,0,1,1,0-4.57h2.31V254a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M192.21,251.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M194.61,256.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M191.79,249a2.32,2.32,0,1,1-2.32-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "secure-2",
      "data-name": "secure"
    }, {
      children: [jsx("path", {
        d: "M19,11V7A7,7,0,0,0,5,7v4H2V23H22V11ZM7,7A5,5,0,0,1,17,7v4H7ZM20,21H4V13H20Z"
      }), jsx("rect", {
        x: "7",
        y: "16",
        width: "10",
        height: "2"
      })]
    }))]
  }))
}));

const SecurePolicy = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M229.48,176.28a2.29,2.29,0,1,1,0-4.57h2.31V174a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M232.21,171.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M234.61,176.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M231.79,169a2.32,2.32,0,1,1-2.32-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "secure-policy"
    }, {
      children: [jsx("path", {
        d: "M1,1V23H23V1ZM21,21H3V3H21Z"
      }), jsx("path", {
        d: "M18,11H16V8A4,4,0,0,0,8,8v3H6v8H18ZM10,8a2,2,0,0,1,4,0v3H10Z"
      })]
    }))]
  }))
}));

const SecureShare = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsx("path", {
      d: "M14 8V10H19V22H5V10H10V8H3V24H21V8H14Z"
    }), jsx("path", {
      d: "M11 16H13V3.83L16 6.83V4L12 0L8 4V6.83L11 3.83V16Z"
    })]
  }))
}));

const Settings = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M149.48,256.28a2.29,2.29,0,1,1,0-4.57h2.31V254a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M152.21,251.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M154.61,256.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M151.79,249a2.32,2.32,0,1,1-2.32-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsx("g", Object.assign({
      id: "settings"
    }, {
      children: jsx("path", {
        d: "M23.83,14.25l.21-2-2-.21V12a9.84,9.84,0,0,0-.23-2.12l1.95-.64-.62-1.9-2,.64a10.68,10.68,0,0,0-1.09-1.89l1.53-1.38L20.25,3.23,18.72,4.61A10.61,10.61,0,0,0,17,3.32l.83-1.88L16,.63l-.84,1.88A9.39,9.39,0,0,0,13,2.05V0H11V2.05a9.39,9.39,0,0,0-2.13.46L8,.63l-1.82.81L7,3.32A10.61,10.61,0,0,0,5.28,4.61L3.75,3.23,2.41,4.71,3.94,6.09A10.68,10.68,0,0,0,2.85,8L.9,7.34.28,9.24l2,.64A9.84,9.84,0,0,0,2,12v.05l-2,.21.21,2,2-.22a9.74,9.74,0,0,0,.68,2.08l-1.78,1,1,1.74,1.78-1a10.16,10.16,0,0,0,1.46,1.61L4.14,21.12,5.76,22.3,7,20.63a9.29,9.29,0,0,0,2,.89l-.42,2,2,.42.43-2a9.93,9.93,0,0,0,2.18,0l.43,2,2-.42-.42-2a9.29,9.29,0,0,0,2-.89l1.21,1.67,1.62-1.18-1.21-1.67a10.16,10.16,0,0,0,1.46-1.61l1.78,1,1-1.74-1.78-1A9.74,9.74,0,0,0,21.79,14ZM11,4.07V8.14A4,4,0,0,0,8.14,11H4.07A8,8,0,0,1,11,4.07Zm0,15.86A8,8,0,0,1,4.07,13H8.14A4,4,0,0,0,11,15.86ZM10,12a2,2,0,1,1,2,2A2,2,0,0,1,10,12Zm3,7.93V15.86A4,4,0,0,0,15.86,13h4.07A8,8,0,0,1,13,19.93ZM15.86,11A4,4,0,0,0,13,8.14V4.07A8,8,0,0,1,19.93,11Z"
      })
    }))]
  }))
}));

const Submissions = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "Layer_6",
      "data-name": "Layer 6"
    }, {
      children: [jsx("rect", {
        x: "5",
        y: "9",
        width: "9",
        height: "2",
        fill: "#43a2d3"
      }), jsx("rect", {
        x: "5",
        y: "13",
        width: "9",
        height: "2",
        fill: "#43a2d3"
      }), jsx("rect", {
        x: "5",
        y: "17",
        width: "9",
        height: "2",
        fill: "#43a2d3"
      }), jsx("path", {
        d: "M1,23H18V19h5V1H6V5H1ZM8,3H21V17H18V5H8ZM3,7H16V21H3Z",
        fill: "#43a2d3"
      })]
    }))
  }))
}));

const Templates = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsx("g", Object.assign({
      id: "templates"
    }, {
      children: jsx("path", {
        d: "M18.41,1H1V23H23V5.59Zm-.82,2,2,2H3V3ZM3,21V7H21V21Z"
      })
    }))
  }))
}));

const Text = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "text"
    }, {
      children: [jsx("path", {
        d: "M1,1V23H23V1ZM21,21H3V3H21Z"
      }), jsx("rect", {
        x: "6",
        y: "6",
        width: "12",
        height: "2"
      }), jsx("rect", {
        x: "6",
        y: "11",
        width: "11",
        height: "2"
      }), jsx("rect", {
        x: "6",
        y: "16",
        width: "11",
        height: "2"
      })]
    }))
  }))
}));

const Tick = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M189.48-23.72A2.31,2.31,0,0,1,187.16-26a2.3,2.3,0,0,1,2.32-2.29h2.31V-26a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M192.21-28.71v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M194.61-23.72a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M191.79-31a2.3,2.3,0,0,1-2.32,2.29A2.29,2.29,0,0,1,187.16-31a2.29,2.29,0,0,1,2.31-2.28A2.3,2.3,0,0,1,191.79-31",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "tick"
    }, {
      children: [jsx("polygon", {
        points: "10.42 16.09 8.58 13.81 6 13.81 9.4 18 11.67 18 18.07 6 15.8 6 10.42 16.09"
      }), jsx("path", {
        d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z"
      })]
    }))]
  }))
}));

const TriangleDown = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M189.48-103.72a2.31,2.31,0,0,1-2.32-2.28,2.3,2.3,0,0,1,2.32-2.29h2.31V-106a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M192.21-108.71v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M194.61-103.72a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M191.79-111a2.3,2.3,0,0,1-2.32,2.29,2.29,2.29,0,0,1-2.31-2.29,2.29,2.29,0,0,1,2.31-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsx("g", Object.assign({
      id: "triangle-up"
    }, {
      children: jsx("polygon", {
        points: "18 7 6 7 12 18 18 7"
      })
    }))]
  }))
}));

const TriangleRight = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M168.48-143.72a2.31,2.31,0,0,1-2.32-2.28,2.3,2.3,0,0,1,2.32-2.29h2.31V-146a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M171.21-148.71v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M173.61-143.72a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M170.79-151a2.3,2.3,0,0,1-2.32,2.29,2.29,2.29,0,0,1-2.31-2.29,2.29,2.29,0,0,1,2.31-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsx("g", Object.assign({
      id: "triangle-right"
    }, {
      children: jsx("polygon", {
        points: "6.9 6.37 6.9 18.37 17.9 12.37 6.9 6.37"
      })
    }))]
  }))
}));

const TriangleUp = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M149.48-103.72a2.31,2.31,0,0,1-2.32-2.28,2.3,2.3,0,0,1,2.32-2.29h2.31V-106a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M152.21-108.71v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M154.61-103.72a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M151.79-111a2.3,2.3,0,0,1-2.32,2.29,2.29,2.29,0,0,1-2.31-2.29,2.29,2.29,0,0,1,2.31-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsx("g", Object.assign({
      id: "triangle-down"
    }, {
      children: jsx("polygon", {
        points: "6 17 18 17 12 6 6 17"
      })
    }))]
  }))
}));

const Undo = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M288.48-143.72a2.31,2.31,0,0,1-2.32-2.28,2.3,2.3,0,0,1,2.32-2.29h2.31V-146a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M291.21-148.71v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M293.61-143.72a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M290.79-151a2.3,2.3,0,0,1-2.32,2.29,2.29,2.29,0,0,1-2.31-2.29,2.29,2.29,0,0,1,2.31-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsx("g", Object.assign({
      id: "ICONS"
    }, {
      children: jsx("path", {
        d: "M12.66,14l-3-3h3.67a2.5,2.5,0,0,1,1.77,4.27l-.71.7,1.41,1.42.71-.71A4.5,4.5,0,0,0,13.33,9H9.66l3-3H9.83l-4,4,4,4Z"
      })
    }))]
  }))
}));

const Unsecure = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsx("g", Object.assign({
      id: "unsecure"
    }, {
      children: jsx("path", {
        d: "M7,11V7A5,5,0,0,1,17,7V8h2V7A7,7,0,0,0,5,7v4H3V23H21V11ZM19,21H5V13H19Z"
      })
    }))
  }))
}));

const UnViewed = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsx("g", Object.assign({
      id: "unviewed"
    }, {
      children: jsx("circle", {
        cx: "12",
        cy: "12",
        r: "8"
      })
    }))
  }))
}));

const Upload = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M309.48,56.28a2.29,2.29,0,1,1,0-4.57h2.31V54a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M312.21,51.29V46.72a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M314.61,56.28a2.28,2.28,0,0,1-2.4-2.23V51.71h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M311.79,49a2.32,2.32,0,1,1-2.32-2.28A2.3,2.3,0,0,1,311.79,49",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "upload"
    }, {
      children: [jsx("path", {
        d: "M19.44,7.09A8,8,0,0,0,4.06,9a4.49,4.49,0,0,0,.44,9H6V16H4.5a2.5,2.5,0,1,1,1.75-4.28A6,6,0,0,1,12,4a6,6,0,0,1,5.92,5.06A3.68,3.68,0,0,1,18.5,9a3.5,3.5,0,0,1,0,7H18v2h.5a5.5,5.5,0,0,0,.94-10.91Z"
      }), jsx("polygon", {
        points: "8 13 8 15.83 11 12.83 11 23 13 23 13 12.83 16 15.83 16 13 12 9 8 13"
      })]
    }))]
  }))
}));

const UserAnsarada = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M208.48-183.72a2.31,2.31,0,0,1-2.32-2.28,2.3,2.3,0,0,1,2.32-2.29h2.31V-186a2.3,2.3,0,0,1-2.31,2.28",
          fill: "none",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M211.21-188.71v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          fill: "none",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M213.61-183.72a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          fill: "none",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M210.79-191a2.3,2.3,0,0,1-2.32,2.29,2.29,2.29,0,0,1-2.31-2.29,2.29,2.29,0,0,1,2.31-2.28,2.3,2.3,0,0,1,2.32,2.28",
          fill: "none",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "Layer_6",
      "data-name": "Layer 6"
    }, {
      children: [jsx("path", {
        d: "M1,1V23H23V1ZM21,21H3V3H21Z",
        fill: "#06ac47"
      }), jsx("path", {
        d: "M8.88,18.22A2.79,2.79,0,0,1,6,15.47a2.86,2.86,0,0,1,2.88-2.86h2.76v2.86A2.7,2.7,0,0,1,8.88,18.22Z",
        fill: "#06ac47"
      }), jsx("path", {
        d: "M12.43,11.75V6.22A5.4,5.4,0,0,1,18,11.75Z",
        fill: "#06ac47"
      }), jsx("path", {
        d: "M15.31,18.22a2.68,2.68,0,0,1-2.88-2.62v-3H18v5.61Z",
        fill: "#06ac47"
      }), jsx("circle", {
        cx: "8.82",
        cy: "9.04",
        r: "2.82",
        fill: "#06ac47"
      })]
    }))]
  }))
}));

const UserBuysideGroup = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M309.48-183.72a2.31,2.31,0,0,1-2.32-2.28,2.3,2.3,0,0,1,2.32-2.29h2.31V-186a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M312.21-188.71v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M314.61-183.72a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M311.79-191a2.3,2.3,0,0,1-2.32,2.29,2.29,2.29,0,0,1-2.31-2.29,2.29,2.29,0,0,1,2.31-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsx("g", Object.assign({
      id: "userr-buyside-group"
    }, {
      children: jsx("path", {
        d: "M1,1V23H23V1ZM8.83,11c0-2.21,1.42-4,3.17-4s3.17,1.79,3.17,4S13.75,15,12,15,8.83,13.21,8.83,11ZM21,21H18.82l-1-5h-3a6.31,6.31,0,0,0,2.32-5c0-3.31-2.32-6-5.17-6S6.83,7.69,6.83,11a6.31,6.31,0,0,0,2.32,5H6.43l-3,5H3V3H21Z"
      })
    }))]
  }))
}));

const UserBuyside = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "user-buyside"
    }, {
      children: [jsx("path", {
        d: "M19,8c0-4.42-3.13-8-7-8S5,3.58,5,8s3.13,8,7,8S19,12.42,19,8Zm-7,6c-2.76,0-5-2.69-5-6s2.24-6,5-6,5,2.69,5,6S14.76,14,12,14Z"
      }), jsx("polygon", {
        points: "19 16 12 16 5 16 1 23 21 23 19 16"
      })]
    }))
  }))
}));

const UserSellsideGroup = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsx("g", Object.assign({
      id: "user-sellside-group"
    }, {
      children: jsx("path", {
        d: "M1,1V23H23V1ZM8.83,11c0-2.21,1.42-4,3.17-4s3.17,1.79,3.17,4S13.75,15,12,15,8.83,13.21,8.83,11ZM7.22,21l.6-3h8.61l1.8,3ZM21,21h-.43l-3-5H14.85a6.31,6.31,0,0,0,2.32-5c0-3.31-2.32-6-5.17-6S6.83,7.69,6.83,11a6.31,6.31,0,0,0,2.32,5h-3l-1,5H3V3H21Z"
      })
    }))
  }))
}));

const UserSellside = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "user-sellside"
    }, {
      children: [jsx("path", {
        d: "M19,8c0-4.42-3.13-8-7-8S5,3.58,5,8s3.13,8,7,8S19,12.42,19,8Zm-7,6c-2.76,0-5-2.69-5-6s2.24-6,5-6,5,2.69,5,6S14.76,14,12,14Z"
      }), jsx("polygon", {
        points: "19 16 12 16 5 16 3 23 5.08 23 6.51 18 17.84 18 20.7 23 23 23 19 16"
      })]
    }))
  }))
}));

const Video = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "video"
    }, {
      children: [jsx("path", {
        d: "M1,1V23H23V1ZM21,21H3V3H21Z"
      }), jsx("polygon", {
        points: "7 6 7 18 18 12 7 6"
      })]
    }))
  }))
}));

const View = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M269.48,56.28a2.29,2.29,0,1,1,0-4.57h2.31V54a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M272.21,51.29V46.72a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M274.61,56.28a2.28,2.28,0,0,1-2.4-2.23V51.71h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M271.79,49a2.32,2.32,0,1,1-2.32-2.28A2.3,2.3,0,0,1,271.79,49",
          clipRule: "evenodd"
        })
      }))]
    }), jsx("g", Object.assign({
      id: "view"
    }, {
      children: jsx("path", {
        d: "M23.92,13.1a12.59,12.59,0,0,0-2.79-4A13,13,0,0,0,17,6.47a13.4,13.4,0,0,0-4.38-.93,5.14,5.14,0,0,0-1.28,0A13.4,13.4,0,0,0,7,6.47,13,13,0,0,0,2.87,9.13a12.59,12.59,0,0,0-2.79,4l-.23.54.36.47a9,9,0,0,0,2.87,2.35A16,16,0,0,0,7.13,18,21.44,21.44,0,0,0,12,18.5,21.44,21.44,0,0,0,16.87,18a16,16,0,0,0,4.05-1.5,9,9,0,0,0,2.87-2.35l.36-.47ZM16,11.5a4,4,0,1,1-4.07-4h.14A4,4,0,0,1,16,11.5ZM4,14.71a8.38,8.38,0,0,1-1.86-1.37,10.46,10.46,0,0,1,2.07-2.76A10.79,10.79,0,0,1,6.62,8.86a6,6,0,0,0,1.57,7.27c-.2,0-.41-.07-.61-.12A14.31,14.31,0,0,1,4,14.71Zm15.92,0A14.31,14.31,0,0,1,16.42,16c-.2,0-.41.08-.61.12a6,6,0,0,0,1.57-7.27,10.79,10.79,0,0,1,2.37,1.72,10.46,10.46,0,0,1,2.07,2.76A8.38,8.38,0,0,1,20,14.71Z"
      })
    }))]
  }))
}));

const Viewed = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsx("g", Object.assign({
      id: "viewed"
    }, {
      children: jsx("path", {
        d: "M12,20a8,8,0,1,1,8-8A8,8,0,0,1,12,20ZM12,6a6,6,0,1,0,6,6A6,6,0,0,0,12,6Z"
      })
    }))
  }))
}));

const Visio = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M269.48,216.28a2.29,2.29,0,1,1,0-4.57h2.31V214a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M272.21,211.29v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M274.61,216.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M271.79,209a2.32,2.32,0,1,1-2.32-2.28,2.3,2.3,0,0,1,2.32,2.28",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "visio"
    }, {
      children: [jsx("path", {
        d: "M1,1V23H23V1ZM21,21H3V3H21Z"
      }), jsx("polygon", {
        points: "13.18 18 17.67 6.04 14.99 6.04 12.01 14.5 9.11 6.04 6.33 6.04 10.82 18 13.18 18"
      })]
    }))]
  }))
}));

const Warning = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M269.48-23.72A2.31,2.31,0,0,1,267.16-26a2.3,2.3,0,0,1,2.32-2.29h2.31V-26a2.3,2.3,0,0,1-2.31,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M272.21-28.71v-4.57a4.49,4.49,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M274.61-23.72a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M271.79-31a2.3,2.3,0,0,1-2.32,2.29A2.29,2.29,0,0,1,267.16-31a2.29,2.29,0,0,1,2.31-2.28A2.3,2.3,0,0,1,271.79-31",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "warning"
    }, {
      children: [jsx("path", {
        d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z"
      }), jsx("rect", {
        x: "11",
        y: "7",
        width: "2",
        height: "6"
      }), jsx("rect", {
        x: "11",
        y: "15",
        width: "2",
        height: "2"
      })]
    }))]
  }))
}));

const Watermark = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "watermark"
    }, {
      children: [jsx("path", {
        d: "M1,1V23H23V1ZM21,21H3V3H21Z"
      }), jsx("polygon", {
        points: "19 4.76 5 11.76 5 14 19 7 19 4.76"
      }), jsx("polygon", {
        points: "19 9.76 5 16.76 5 19 19 12 19 9.76"
      })]
    }))
  }))
}));

const Word = props => jsx(Icon, Object.assign({}, props, {
  children: jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, {
    children: jsxs("g", Object.assign({
      id: "word"
    }, {
      children: [jsx("path", {
        d: "M1,1V23H23V1ZM21,21H3V3H21Z"
      }), jsx("polygon", {
        points: "9.87 18 12.03 9.16 14.26 18 16.69 18 19.94 6.04 17.26 6.04 15.45 14.35 13.41 6.11 10.76 6.11 8.8 14.35 6.88 6.04 4.06 6.04 7.51 18 9.87 18"
      })]
    }))
  }))
}));

const Workflow = props => jsx(Icon, Object.assign({}, props, {
  children: jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, {
    children: [jsxs("defs", {
      children: [jsx("clipPath", Object.assign({
        id: "clip-path"
      }, {
        children: jsx("path", {
          d: "M-27.54,176.28A2.31,2.31,0,0,1-29.87,174a2.3,2.3,0,0,1,2.33-2.29h2.3V174a2.3,2.3,0,0,1-2.3,2.28",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-2"
      }, {
        children: jsx("path", {
          d: "M-24.82,171.29v-4.57a4.48,4.48,0,0,1,4.63,4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-3"
      }, {
        children: jsx("path", {
          d: "M-22.42,176.28a2.28,2.28,0,0,1-2.4-2.23v-2.34h4.63v4.57Z",
          clipRule: "evenodd"
        })
      })), jsx("clipPath", Object.assign({
        id: "clip-path-4"
      }, {
        children: jsx("path", {
          d: "M-25.24,169a2.29,2.29,0,0,1-2.31,2.29A2.3,2.3,0,0,1-29.87,169a2.3,2.3,0,0,1,2.32-2.28A2.29,2.29,0,0,1-25.24,169",
          clipRule: "evenodd"
        })
      }))]
    }), jsxs("g", Object.assign({
      id: "Layer_6",
      "data-name": "Layer 6"
    }, {
      children: [jsx("path", {
        d: "M18,8V3H12A2,2,0,1,0,8,3H2V21H7v2H22V8ZM4,19V5H6V6h8V5h2V8H7V19Zm16,2H9V10H20Z"
      }), jsx("rect", {
        x: "10.97",
        y: "12",
        width: "7",
        height: "2"
      }), jsx("rect", {
        x: "10.97",
        y: "16",
        width: "7",
        height: "2"
      })]
    }))]
  }))
}));

export { Acrobat, Actions, AddColumn, AddItem, AddSection, AddSectionAbove, AddSectionBelow, AddTab, Administrator, Archive, Archived, ArrowCollapseAll, ArrowDown, ArrowExpandAll, ArrowIndent, ArrowLeft, ArrowRight, ArrowSortDown, ArrowSortUp, ArrowUp, Attachment, Audio, AwaitingAction, Broken, ChevronCollapsed, ChevronExpanded, CloseLarge, CloseSmall, Cloud, Colour, Contact, Copy, CopyDeny, CopyTick, Cross, CrossStatus, Date, Deny, Design, Disable, Document, DocumentIndex, Download, Drag, Duplicate, Edit, EditDeny, EditTick, Email, EmailDeny, EmailGroup, EmailInvite, EmailTick, Enable, Evaluation, Excel, ExternalLink, Filter, Folder, FolderEmpty, FolderRoot, FormatBold, FormatBoldActive, FormatItalic, FormatItalicActive, FormatList, FormatListActive, FormatUnderline, FormatUnderlineActive, HeartOutline, HeartSolid, Help, Hide, History, Html, Icon, Image, Information, Item, Language, Link, LogomarkAnsarada, LogomarkKira, ManageDocuments, ManageUser, Menu, MenuContextual, Move, Notification, Number, Pin, Plus, Powerpoint, Print, PrintDeny, PrintTick, PriorityHigh, PriorityLow, PriorityMedium, QnAActions, QnAAnswer, QnAComment, QnAForward, QnAManage, QnAQuestion, QnASubject, QnASubjectGroup, QnATick, QnAViewer, Redact, RedactArea, RedactPage, RedactPattern, RedactText, Report, Revert, Save, SaveDeny, SaveTick, Scorecards, Search, Secure, SecurePolicy, SecureShare, Settings, Submissions, Templates, Text, Tick, TriangleDown, TriangleRight, TriangleUp, UnViewed, Undo, Unsecure, Upload, UserAnsarada, UserBuyside, UserBuysideGroup, UserSellside, UserSellsideGroup, Video, View, Viewed, Visio, Warning, Watermark, Word, Workflow };
